<template>
 <div id="g-page" >

  <table id="main-table-screen" border="0">
    <tr>
      <td id="main-table-row1" colspan="1"> 
      </td>
    </tr>

    <tr>
      <td id="main-table-row2-dialog-container-td">
        
        <table class="dialog-table" align="center" border="0">
          <tr>
            <td id="dialog-td-title" class="radius-single-left-field-left-top radius-single-left-field-left-bottom radius-single-left-field-right-top radius-single-left-field-right-bottom" >
                <p class="wrap"> {{ $t("DQ.title1") }}</p>
            </td>
            <td id="dialog-td-instructions" class="radius-single-right-field-left-top radius-single-right-field-left-bottom radius-single-right-field-right-top radius-single-right-field-right-bottom">
              {{ $t("DQ.title2") }} 
              <span style="font-size:14pt">{{ $t("DQ.title3") }}</span>
            </td>
          </tr>
        </table>

        <table class="dialog-table" align="center" border="0">
          <!-- 
            *************************************
            *        SECTION 1 MOOD             *
            *************************************
          -->
          <div style="height:10px;"></div>
          <tr>
            <td class="dialog-signon-td-section-title radius-top-left-field-top radius-top-left-field-bottom radius-top-right-field-top radius-top-right-field-bottom" colspan="3">
              <p> {{ $t("DQ.s1Title") }}</p><!--SECTION 1 MOOD-->
            </td>
          </tr>
          <tr>
            <td class="dialog-question-space" colspan="3">
              <div style="height:20px" />
            </td>
          </tr>
          <tr>
            <!-- QUESTION 1 MOOD -->
            <td id="mood-1" colspan="1">
              <p class="wrap"> {{ $t("DQ.s1QMood") }}</p>
              <!--How would you rate your mood today.-->
            </td>
            <td id="mood-2" colspan="2"> 
              <table style="width:100%" border="0">
                <tr>
                  <td class="mood">
                    <label for="selectOneChecked">{{ $t("DQ.selectOne") }}</label>&nbsp;
                    <input type="radio" name="selectOneChecked" value="0" v-model="input.sec1MoodRating">
                  </td>
                  <td class="mood">
                    <label for="moodRatingBadChecked">{{ $t("DQ.moodRatingBad") }}</label>&nbsp;
                    <input type="radio" name="moodRatingBadChecked" value="1" v-model="input.sec1MoodRating">
                  </td>
                  <td class="mood">
                    <label for="moodRatingNotGoodChecked">{{ $t("DQ.moodRatingNotGood") }}</label>&nbsp;
                    <input type="radio" name="moodRatingNotGoodChecked" value="2" v-model="input.sec1MoodRating">
                  </td>
                  <td class="mood">
                    <label for="moodRatingAverageChecked">{{ $t("DQ.moodRatingAverage") }}</label>&nbsp;
                    <input type="radio" name="moodRatingAverageChecked" value="3" v-model="input.sec1MoodRating">
                  </td>
                  <td class="mood">
                    <label for="moodRatingGoodChecked">{{ $t("DQ.moodRatingGood") }}</label>&nbsp;
                    <input type="radio" name="moodRatingGoodChecked" value="4" v-model="input.sec1MoodRating">
                  <td>
                  <td class="mood">
                    <label for="moodRatingGreatChecked">{{ $t("DQ.moodRatingGreat") }}</label>&nbsp;
                    <input type="radio" name="moodRatingGreatChecked" value="5" v-model="input.sec1MoodRating">
                  </td>
                </tr>
              </table>
            </td>
          </tr>

          <tr>
            <td colspan="3" class="radius-bottom-left-field-top radius-bottom-left-field-bottom radius-bottom-right-field-top radius-bottom-right-field-bottom" style="background-color:#343F68">
              <div style="height:15px;"></div>
            </td>
          </tr>
        </table>

        <table class="dialog-table" align="center" border="0">
          <!-- 
            *******************************************************************
            *        SECTION 2 - PRE-WORK SHIFT MEDICAL CHECKLIST             *
            *******************************************************************
          -->
          <div style="height:10px;"></div>
          <tr>
            <td class="dialog-signon-td-section-title radius-top-left-field-top radius-top-left-field-bottom radius-top-right-field-top radius-top-right-field-bottom" colspan="3">
              <p class="wrap"> {{ $t("DQ.s2Title") }}</p><!--SECTION 2 - PRE-WORK SHIFT MEDICAL CHECKLIST-->
            </td>
          </tr>
          <tr>
            <td class="dialog-question-space" colspan="3">
              <div style="height:20px" />
            </td>
          </tr>
          <tr>
            <td class="dialog-question" colspan="3">
              <p class="wrap"> {{ $t("DQ.s2Statement")}}</p><!--Please complete the following information prior to showing up to your workplace.-->
              <div style="height:10px" />
            </td>
          </tr>
          <tr>
            <!-- ILLNESS - ARE YOU FEELING SICK-->
            <td class="dialog-question-space border-dots">

            </td>
            <td class="dialog-sub-question border-dots-inner" colspan="1">             
              {{ $t("DQ.s2QIllness") }}
              <!-- "Illness – Are you feeling sick?-->
            </td>
            <td class="dialog-input-field-right border-dots" colspan="2">
              <label for="sec2IllnessFeelingSickYes">{{ $t("DQ.yes") }}</label>&nbsp;
              <input type="radio" name="sec2IllnessFeelingSick" :value="true" v-model="input.sec2IllnessFeelingSick">
              &nbsp;
              <label for="sec2IllnessFeelingSickNo">{{ $t("DQ.no") }}</label>&nbsp;
              <input type="radio" name="sec2IllnessFeelingSick" :value="false" v-model="input.sec2IllnessFeelingSick"
              @click="onSec2IllnessFeelingSick">
            </td>
          </tr>

          <tr v-if="input.sec2IllnessFeelingSick == true">
            <!-- ILLNESS - DO YOU BELIEVE THAT THIS COIULD INTERFERE WITH YOUR DUTIES? -->
            <td class="dialog-question-space-alt">

            </td>
            <td colspan="2" class="dialog-sub-question-alt border-dots-inner">
              <table style="width:100%" border="0">      
                <tr>
                  <td class="dialog-question-space-alt">
                  </td>
                  <td class="dialog-sub-question-alt border-dots-inner">
                    {{ $t("DQ.s2QIllnessQ1") }}
                    <!--Do you believe that this could interfere with your duties?-->
                  </td>
                  <td class="dialog-input-field-right-alt border-dots-inner">
                    <label for="sec2IllnessInterfereWithDutiesYes">{{ $t("DQ.yes") }}</label>&nbsp;
                    <input type="radio" name="sec2IllnessInterfereWithDuties" :value="true" v-model="input.sec2IllnessInterfereWithDuties">
                    &nbsp;
                    <label for="sec2IllnessInterfereWithDutiesNo">{{ $t("DQ.no") }}</label>&nbsp;
                    <input type="radio" name="sec2IllnessInterfereWithDuties" :value="false" v-model="input.sec2IllnessInterfereWithDuties"
                    @click="onSec2IllnessInterfereWithDuties">
                  </td>
                </tr>
              </table>
            </td>
          </tr>

          <tr v-if="input.sec2IllnessFeelingSick == true">
            <!-- ILLNESS - EXPLAIN-->
            <td class="dialog-question-space">

            </td>
            <td colspan="2" class="dialog-sub-question border-dots-inner">
              <table style="width:100%" border="0">           
                <tr>
                  <td class="dialog-question-space">
                  </td>
                  <td>    
                    {{ $t("DQ.ifYesExplain") }}
                    <!-- If yes then please explain:-->  
                  </td>
                  <td class="dialog-input-field-explain border-dots"> 
                    <textarea name="sec2IllnessExplanation" 
                      cols=2
                      style="width:100%;resize: none;height:100%;border-radius:5px;"
                      v-model="input.sec2IllnessExplanation"
                      v-bind:placeholder="$t('DQ.explain')" 
                      :disabled="!input.sec2IllnessInterfereWithDuties"
                      :class="input.sec2IllnessInterfereWithDuties ? 'enabled' : 'disabled'"
                      maxlength="500"
                    />
                  </td>
                </tr>
              </table>   
            </td>
          </tr> 

          <tr>
            <!--2. Are  you taking any medications or supplements?-->
            <td class="dialog-question-space-alt border-dots">

            </td>
            <td class="dialog-sub-question-alt border-dots-inner" colspan="1">             
              {{ $t("DQ.s2QMeds") }}
              <!--2. Are  you taking any medications or supplements?-->
            </td>
            <td class="dialog-input-field-right-alt border-dots-inner" colspan="2">
              <label for="sec3MedsTakingAllYes">{{ $t("DQ.yes") }}</label>&nbsp;
              <input type="radio" name="sec3MedsTakingAny" :value="true" v-model="input.sec3MedsTakingAny">
              &nbsp;
              <label for="sec3MedsTakingAllNo">{{ $t("DQ.no") }}</label>&nbsp;
              <input type="radio" name="sec3MedsTakingAny" :value="false" v-model="input.sec3MedsTakingAny"
              @click="onSec3MedsTakingAll">
            </td>
          </tr>

          <tr v-if="input.sec3MedsTakingAny == true">
            <!--b. Have you taken any medication that could affect your state of mind?-->
            <td class="dialog-question-space">

            </td>
            <td colspan="2" class="dialog-sub-question border-dots-inner">
              <table style="width:100%" border="0">      
                <tr>
                  <td class="dialog-question-space">
                  </td>
                  <td class="dialog-sub-question border-dots-inner">
                    {{ $t("DQ.s2QMedsQ1") }}
                    <!--a. Have you been taking your medications as prescribed by your physician?-->
                  </td>
                  <td class="dialog-input-field-right border-dots">
                    <label for="sec3MedsTakingAsPrescribedYes">{{ $t("DQ.yes") }}</label>&nbsp;
                    <input type="radio" name="sec3MedsTakingAsPrescribed" :value="true" v-model="input.sec3MedsTakingAsPrescribed">
                    &nbsp;
                    <label for="sec3MedsTakingAsPrescribedNo">{{ $t("DQ.no") }}</label>&nbsp;
                    <input type="radio" name="sec3MedsTakingAsPrescribed" :value="false" v-model="input.sec3MedsTakingAsPrescribed">
                  </td>
                </tr>
              </table>
            </td>
          </tr>

          <tr v-if="input.sec3MedsTakingAny == true">
            <!--b. Have you taken any medication that could affect your state of mind?-->
            <td class="dialog-question-space-alt">

            </td>
            <td colspan="2" class="dialog-sub-question-alt border-dots-inner">
              <table style="width:100%" border="0">      
                <tr>
                  <td class="dialog-question-space-alt">
                  </td>
                  <td class="dialog-sub-question-alt border-dots-inner">
                    {{ $t("DQ.s2QMedsQ2") }}
                    <!--b. Have you taken any medication that could affect your state of mind?-->
                  </td>
                  <td class="dialog-input-field-right-alt border-dots">
                    <label for="sec3MedsStateOfMindYes">{{ $t("DQ.yes") }}</label>&nbsp;
                    <input type="radio" name="sec3MedsStateOfMind" :value="true" v-model="input.sec3MedsStateOfMind">
                    &nbsp;
                    <label for="sec3MedsStateOfMindNo">{{ $t("DQ.no") }}</label>&nbsp;
                    <input type="radio" name="sec3MedsStateOfMind" :value="false" v-model="input.sec3MedsStateOfMind">
                  </td>
                </tr>
              </table>
            </td>
          </tr>

          <tr v-if="input.sec3MedsTakingAny == true">
            <!-- c. HAVE YOU TAKEN ANY MEDICATIONS THAT COULD INTERFERE WITH OVERALL SAFETY WHILE ON THE JOB? -->
            <td class="dialog-question-space">

            </td>
            <td colspan="2" class="dialog-sub-question border-dots-inner">
              <table style="width:100%" border="0">      
                <tr>
                  <td class="dialog-question-space">
                  </td>
                  <td class="dialog-sub-question border-dots-inner">
                    {{ $t("DQ.s2QMedsQ3") }}
                    <!--c. Have you taken any medications that could interfere with overall safety while on the job?-->
                  </td>
                  <td class="dialog-input-field-right border-dots">
                    <label for="sec3MedsInterfereWithJobYes">{{ $t("DQ.yes") }}</label>&nbsp;
                    <input type="radio" name="sec3MedsInterfereWithJob" :value="true" v-model="input.sec3MedsInterfereWithJob">
                    &nbsp;
                    <label for="sec3MedsInterfereWithJobNo">{{ $t("DQ.no") }}</label>&nbsp;
                    <input type="radio" name="sec3MedsInterfereWithJob" :value="false" v-model="input.sec3MedsInterfereWithJob">
                  </td>
                </tr>
              </table>
            </td>
          </tr>

          <tr v-if="input.sec3MedsTakingAny == true">
            <!-- d. ARE YOU TAKING ANY SUPPLEMENTS? -->
            <td class="dialog-question-space-alt">

            </td>
            <td colspan="2" class="dialog-sub-question-alt border-dots-inner">
              <table style="width:100%" border="0">      
                <tr>
                  <td class="dialog-question-space-alt">
                  </td>
                  <td class="dialog-sub-question-alt border-dots-inner">
                    {{ $t("DQ.s2QMedsQ4") }}
                    <!--d. Are you taking any supplements?-->
                  </td>
                  <td class="dialog-input-field-right-alt border-dots">
                    <label for="sec3MedsTakingSupplementsYes">{{ $t("DQ.yes") }}</label>&nbsp;
                    <input type="radio" name="sec3MedsTakingSupplements" :value="true" v-model="input.sec3MedsTakingSupplements">
                    &nbsp;
                    <label for="sec3MedsTakingSupplementsNo">{{ $t("DQ.no") }}</label>&nbsp;
                    <input type="radio" name="sec3MedsTakingSupplements" :value="false" v-model="input.sec3MedsTakingSupplements">
                  </td>
                </tr>
              </table>
            </td>
          </tr>

          <tr v-if="input.sec3MedsTakingAny == true">
            <!-- MEDICATIONS - EXPLAIN-->
            <td class="dialog-question-space">

            </td>
            <td colspan="2" class="dialog-sub-question border-dots-inner">
              <table style="width:100%" border="0">           
                <tr>
                  <td class="dialog-question-space">
                  </td>
                  <td>    
                    {{ $t("DQ.s2QMedsList") }}
                    <!-- If yes then please explain:-->  
                  </td>
                  <td class="dialog-input-field-explain border-dots-inner"> 
                    <textarea name="sec3MedsExplanation" 
                      cols=2
                      style="width:100%;resize: none;height:100%;border-radius:5px;"
                      v-model="input.sec3MedsExplanation"
                      v-bind:placeholder="$t('DQ.listMeds')" 
                      maxlength="500"
                    />
                  </td>
                </tr>
              </table>   
            </td>
          </tr> 

          <tr>
            <!-- STRESS -->
            <td class="dialog-question-space border-dots">

            </td>
            <td class="dialog-sub-question border-dots-inner" colspan="1">             
              {{ $t("DQ.s2QStress") }}
              <!-- "3. Stress – Are you feeling any stress?-->
            </td>
            <td class="dialog-input-field-right border-dots" colspan="2">
              <label for="sec2StressFeelingStresses">{{ $t("DQ.yes") }}</label>&nbsp;
              <input type="radio" name="sec2StressFeelingStress" :value="true" v-model="input.sec2StressFeelingStress">
              &nbsp;
              <label for="sec2StressFeelingStressNo">{{ $t("DQ.no") }}</label>&nbsp;
              <input type="radio" name="sec2StressFeelingStress" :value="false" v-model="input.sec2StressFeelingStress"
              @click="onSec2StressFeelingStress">
            </td>
          </tr>

          <tr v-if="input.sec2StressFeelingStress == true">
            <!-- a. Long workload or work hours? -->
            <td class="dialog-question-space-alt">

            </td>
            <td colspan="2" class="dialog-sub-question-alt border-dots-inner">
              <table style="width:100%" border="0">      
                <tr>
                  <td class="dialog-question-space-alt">
                  </td>
                  <td class="dialog-sub-question-alt border-dots-inner">
                    {{ $t("DQ.s2QStressQ1") }}
                    <!--a. Long workload or work hours? -->
                  </td>
                  <td class="dialog-input-field-right-alt border-dots">
                    <label for="sec2StressLongWorkloadHoursYes">{{ $t("DQ.yes") }}</label>&nbsp;
                    <input type="radio" name="sec2StressLongWorkloadHours" :value="true" v-model="input.sec2StressLongWorkloadHours">
                    &nbsp;
                    <label for="sec3MedsTakingSupplementsNo">{{ $t("DQ.no") }}</label>&nbsp;
                    <input type="radio" name="sec2StressLongWorkloadHours" :value="false" v-model="input.sec2StressLongWorkloadHours">
                  </td>
                </tr>
              </table>
            </td>
          </tr>

          <tr v-if="input.sec2StressFeelingStress == true">
            <!-- b. Workplace challenges? -->
            <td class="dialog-question-space">

            </td>
            <td colspan="2" class="dialog-sub-question border-dots-inner">
              <table style="width:100%" border="0">      
                <tr>
                  <td class="dialog-question-space">
                  </td>
                  <td class="dialog-sub-question border-dots-inner">
                    {{ $t("DQ.s2QStressQ2") }}
                    <!--b. Workplace challenges? -->
                  </td>
                  <td class="dialog-input-field-right border-dots-inner">
                    <label for="sec2StressWorkplaceChallengesYes">{{ $t("DQ.yes") }}</label>&nbsp;
                    <input type="radio" name="sec2StressWorkplaceChallenges" :value="true" v-model="input.sec2StressWorkplaceChallenges">
                    &nbsp;
                    <label for="sec2StressWorkplaceChallengesNo">{{ $t("DQ.no") }}</label>&nbsp;
                    <input type="radio" name="sec2StressWorkplaceChallenges" :value="false" v-model="input.sec2StressWorkplaceChallenges">
                  </td>
                </tr>
              </table>
            </td>
          </tr>

          <tr v-if="input.sec2StressFeelingStress == true">
            <!-- c. Personal causes? -->
            <td class="dialog-question-space-alt">

            </td>
            <td colspan="2" class="dialog-sub-question-alt border-dots-inner">
              <table style="width:100%" border="0">      
                <tr>
                  <td class="dialog-question-space-alt">
                  </td>
                  <td class="dialog-sub-question-alt border-dots-inner">
                    {{ $t("DQ.s2QStressQ3") }}
                    <!--c. Personal causes? -->
                  </td>
                  <td class="dialog-input-field-right-alt border-dots-inner">
                    <label for="sec2StressPersonalCausesYes">{{ $t("DQ.yes") }}</label>&nbsp;
                    <input type="radio" name="sec2StressPersonalCauses" :value="true" v-model="input.sec2StressPersonalCauses">
                    &nbsp;
                    <label for="sec2StressPersonalCausesNo">{{ $t("DQ.no") }}</label>&nbsp;
                    <input type="radio" name="sec2StressPersonalCauses" :value="false" v-model="input.sec2StressPersonalCauses">
                  </td>
                </tr>
              </table>
            </td>
          </tr>

          <tr v-if="input.sec2StressFeelingStress == true">
            <!-- STRESS - EXPLAIN-->
            <td class="dialog-question-space">

            </td>
            <td colspan="2" class="dialog-sub-question border-dots-inner">
              <table style="width:100%" border="0">           
                <tr>
                  <td class="dialog-question-space">
                  </td>
                  <td>    
                    {{ $t("DQ.ifYesMultipleExplain") }}
                    <!-- If yes then please explain:-->  
                  </td>
                  <td class="dialog-input-field-explain border-dots-inner"> 
                    <textarea name="sec2StressExplanation" 
                      cols=2
                      style="width:100%;resize: none;height:100%;border-radius:5px;"
                      v-model="input.sec2StressExplanation"
                      v-bind:placeholder="$t('DQ.explain')" 
                      maxlength="500"
                    />
                  </td>
                </tr>
              </table>   
            </td>
          </tr>

          <tr>
            <!-- ALCOHOL -->
            <td class="dialog-question-space-alt border-dots">

            </td>
            <td class="dialog-sub-question-alt border-dots-inner" colspan="1">             
              {{ $t("DQ.s2QAlcohol") }}
              <!-- "4. Alcohol - Have you consumed any alcohol within the past 24 hours?-->
            </td>
            <td class="dialog-input-field-right-alt border-dots-inner" colspan="2">
              <label for="sec2AlcoholWithinPast24HoursYes">{{ $t("DQ.yes") }}</label>&nbsp;
              <input type="radio" name="sec2AlcoholWithinPast24Hours" :value="true" v-model="input.sec2AlcoholWithinPast24Hours">
              &nbsp;
              <label for="sec2AlcoholWithinPast24HoursNo">{{ $t("DQ.no") }}</label>&nbsp;
              <input type="radio" name="sec2AlcoholWithinPast24Hours" :value="false" v-model="input.sec2AlcoholWithinPast24Hours"
              @click="onSec2AlcoholWithinPast24Hours">
            </td>
          </tr>

          <tr v-if="input.sec2AlcoholWithinPast24Hours == true">
            <!-- a. How many hours has it been since you had your last drink? -->
            <td class="dialog-question-space">

            </td>
            <td colspan="2" class="dialog-sub-question border-dots-inner">
              <table style="width:100%" border="0">      
                <tr>
                  <td class="dialog-question-space">
                  </td>
                  <td class="dialog-sub-question border-dots-inner">
                    {{ $t("DQ.s2QAlcoholQ1") }}
                    <!--a. How many hours has it been since you had your last drink? -->
                  </td>
                  <td class="dialog-input-field-right border-dots">
                    <select name="sec2AlcoholHoursSinceLastDrink" 
                      v-model="input.sec2AlcoholHoursSinceLastDrink"
                      style="border-radius:5px;">
                      <option value="0">{{ $t("DQ.selectOne") }}</option>
                      <option value="1">{{ $t("DQ.oneHour") }}</option>
                      <option value="2">{{ $t("DQ.twoHours") }}</option>
                      <option value="3">{{ $t("DQ.threeHours") }}</option>
                      <option value="4">{{ $t("DQ.fourHours") }}</option>
                      <option value="5">{{ $t("DQ.fiveHours") }}</option>
                      <option value="6">{{ $t("DQ.sixHours") }}</option>
                      <option value="7">{{ $t("DQ.sevenHours") }}</option>
                      <option value="8">{{ $t("DQ.eightHours") }}</option>
                    </select>
                  </td>
                </tr>
              </table>
            </td>
          </tr>

          <tr>
            <!-- FATIGUE -->
            <td class="dialog-question-space border-dots">

            </td>
            
            <!-- FATIGE -->
            <td class="dialog-sub-question border-dots-inner" colspan="1">             
              {{ $t("DQ.s2QFatigue") }}
              <!-- "5. Fatigue - In the past 8 hours, have you experienced any fatigue?-->
            </td>
            <td class="dialog-input-field-right border-dots-inner" colspan="2">
              <label for="sec2FatigueExperiencingYes">{{ $t("DQ.yes") }}</label>&nbsp;
              <input type="radio" name="sec2FatigueExperiencing" :value="true" v-model="input.sec2FatigueExperiencing">
              &nbsp;
              <label for="sec2FatigueExperiencingNo">{{ $t("DQ.no") }}</label>&nbsp;
              <input type="radio" name="sec2FatigueExperiencing" :value="false" v-model="input.sec2FatigueExperiencing"
              @click="onSec2FatigueExperiencing">
            </td>
            
          </tr>

          <tr v-if="input.sec2FatigueExperiencing == true">
            <!-- a. Strenuous muscular effort? -->
            <td class="dialog-question-space-alt">

            </td>
            <td colspan="2" class="dialog-sub-question-alt border-dots-inner">
              <table style="width:100%" border="0">      
                <tr>
                  <td class="dialog-question-space-alt">
                  </td>
                  <td class="dialog-sub-question-alt border-dots-inner">
                    {{ $t("DQ.s2QFatigueQ1") }}
                    <!--a. Strenuous muscular effort? -->
                  </td>
                  <td class="dialog-input-field-right-alt border-dots-inner">
                    <label for="sec2FatigueMuscularYes">{{ $t("DQ.yes") }}</label>&nbsp;
                    <input type="radio" name="sec2FatigueMuscular" :value="true" v-model="input.sec2FatigueMuscular">
                    &nbsp;
                    <label for="sec2FatigueMuscularNo">{{ $t("DQ.no") }}</label>&nbsp;
                    <input type="radio" name="sec2FatigueMuscular" :value="false" v-model="input.sec2FatigueMuscular">
                  </td>
                </tr>
              </table>
            </td>
          </tr>

          <tr v-if="input.sec2FatigueExperiencing == true">
            <!-- b. Heavy mental work? -->
            <td class="dialog-question-space">

            </td>
            <td colspan="2" class="dialog-sub-question border-dots-inner">
              <table style="width:100%" border="0">      
                <tr>
                  <td class="dialog-question-space">
                  </td>
                  <td class="dialog-sub-question border-dots-inner">
                    {{ $t("DQ.s2QFatigueQ2") }}
                    <!--b. Heavy mental work? -->
                  </td>
                  <td class="dialog-input-field-right border-dots-inner">
                    <label for="sec2FatigueMentalYes">{{ $t("DQ.yes") }}</label>&nbsp;
                    <input type="radio" name="sec2FatigueMental" :value="true" v-model="input.sec2FatigueMental">
                    &nbsp;
                    <label for="sec2FatigueMentalNo">{{ $t("DQ.no") }}</label>&nbsp;
                    <input type="radio" name="sec2FatigueMental" :value="false" v-model="input.sec2FatigueMental">
                  </td>
                </tr>
              </table>
            </td>
          </tr>

          <tr v-if="input.sec2FatigueExperiencing == true">
            <!-- c. Strong emotional pressure? -->
            <td class="dialog-question-space-alt">

            </td>
            <td colspan="2" class="dialog-sub-question-alt border-dots-inner">
              <table style="width:100%" border="0">      
                <tr>
                  <td class="dialog-question-space-alt">
                  </td>
                  <td class="dialog-sub-question-alt border-dots-inner">
                    {{ $t("DQ.s2QFatigueQ3") }}
                    <!--c. Strong emotional pressure? -->
                  </td>
                  <td class="dialog-input-field-right-alt border-dots-inner">
                    <label for="sec2FatigueEmotionalYes">{{ $t("DQ.yes") }}</label>&nbsp;
                    <input type="radio" name="sec2FatigueEmotional" :value="true" v-model="input.sec2FatigueEmotional">
                    &nbsp;
                    <label for="sec2FatigueEmotionalNo">{{ $t("DQ.no") }}</label>&nbsp;
                    <input type="radio" name="sec2FatigueEmotional" :value="false" v-model="input.sec2FatigueEmotional">
                  </td>
                </tr>
              </table>
            </td>
          </tr>

          <tr v-if="input.sec2FatigueExperiencing == true">
            <!-- FATIGUE - EXPLAIN-->
            <td class="dialog-question-space">

            </td>
            <td colspan="2" class="dialog-sub-question border-dots-inner">
              <table style="width:100%" border="0">           
                <tr>
                  <td class="dialog-question-space">
                  </td>
                  <td>    
                    {{ $t("DQ.ifYesMultipleExplainFatigue") }}
                    <!-- If yes then please explain:-->  
                  </td>
                  <td class="dialog-input-field-explain border-dots-inner"> 
                    <textarea name="sec2FatigueExplanation" 
                      cols=2
                      style="width:100%;resize: none;height:100%;border-radius:5px;"
                      v-model="input.sec2FatigueExplanation"
                      v-bind:placeholder="$t('DQ.explain')" 
                      maxlength="500"
                    />
                  </td>
                </tr>
              </table>   
            </td>
          </tr>

          <tr>
            <!-- SLEEP -->
            <!-- Please tell us about your recent sleep experience-->
            <td class="dialog-question-space-alt border-dots">

            </td>
            <td class="dialog-sub-question-alt border-dots-inner" colspan="2">             
              {{ $t("DQ.s2QSleep") }}
              <!-- Please tell us about your recent sleep experience-->
            </td>
          </tr>

          <tr>
            <!-- a. Lack of sleep? -->
            <td class="dialog-question-space">

            </td>
            <td colspan="2" class="dialog-sub-question border-dots-inner">
              <table style="width:100%" border="0">      
                <tr>
                  <td class="dialog-question-space">
                  </td>
                  <td class="dialog-sub-question border-dots-inner">
                    {{ $t("DQ.s2QSleepQ0") }}
                    <!--a. Lack of sleep?  -->
                  </td>
                  <td class="dialog-input-field-right border-dots-inner">
                    <label for="sec2FatigueLackOfSleepYes">{{ $t("DQ.yes") }}</label>&nbsp;
                    <input type="radio" name="sec2FatigueLackOfSleep" :value="true" v-model="input.sec2FatigueLackOfSleep">
                    &nbsp;
                    <label for="sec2FatigueLackOfSleepNo">{{ $t("DQ.no") }}</label>&nbsp;
                    <input type="radio" name="sec2FatigueLackOfSleep" :value="false" v-model="input.sec2FatigueLackOfSleep">
                  </td>
                </tr>
              </table>
            </td>
          </tr>

          <tr>
            <!-- c. How many hours did you sleep before this upcoming work shift? -->
            <td class="dialog-question-space-alt">

            </td>
            <td colspan="2" class="dialog-sub-question-alt border-dots-inner">
              <table style="width:100%" border="0">      
                <tr>
                  <td class="dialog-question-space-alt">
                  </td>
                  <td class="dialog-sub-question-alt border-dots-inner">
                    {{ $t("DQ.s2QSleepQ3") }}
                    <!--c. How many hours did you sleep before this upcoming work shift?  -->
                  </td>
                  <td class="dialog-input-field-right-alt border-dots-inner">
                    <select name="sec3FatigueHoursOfSleep" 
                      v-model="input.sec3FatigueHoursOfSleep"
                      style="border-radius:5px;">
                      <option value="0">{{ $t("DQ.selectOne") }}</option>
                      <option value="1">{{ $t("DQ.oneHour") }}</option>
                      <option value="2">{{ $t("DQ.twoHours") }}</option>
                      <option value="3">{{ $t("DQ.threeHours") }}</option>
                      <option value="4">{{ $t("DQ.fourHours") }}</option>
                      <option value="5">{{ $t("DQ.fiveHours") }}</option>
                      <option value="6">{{ $t("DQ.sixHours") }}</option>
                      <option value="7">{{ $t("DQ.sevenHours") }}</option>
                      <option value="8">{{ $t("DQ.eightHours") }}</option>
                    </select>
                  </td>
                </tr>
              </table>
            </td>
          </tr>

          <tr>
            <!-- b. Did you wake restful? -->
            <td class="dialog-question-space">

            </td>
            <td colspan="2" class="dialog-sub-question border-dots-inner">
              <table style="width:100%" border="0">      
                <tr>
                  <td class="dialog-question-space">
                  </td>
                  <td class="dialog-sub-question border-dots-inner">
                    {{ $t("DQ.s2QSleepQ1") }}
                    <!--b. Did you wake restful? -->
                  </td>
                  <td class="dialog-input-field-right border-dots-inner">
                    <label for="sec3FatigueWakeRestfulYes">{{ $t("DQ.yes") }}</label>&nbsp;
                    <input type="radio" name="sec3FatigueWakeRestful" :value="true" v-model="input.sec3FatigueWakeRestful">
                    &nbsp;
                    <label for="sec3FatigueWakeRestfulNo">{{ $t("DQ.no") }}</label>&nbsp;
                    <input type="radio" name="sec3FatigueWakeRestful" :value="false" v-model="input.sec3FatigueWakeRestful">
                  </td>
                </tr>
              </table>
            </td>
          </tr>

          <tr>
            <!-- b. Ongoing chronic Lack of sleep? -->
            <td class="dialog-question-space-alt">

            </td>
            <td colspan="2" class="dialog-sub-question-alt border-dots-inner">
              <table style="width:100%" border="0">      
                <tr>
                  <td class="dialog-question-space-alt">
                  </td>
                  <td class="dialog-sub-question-alt border-dots-inner">
                    {{ $t("DQ.s2QSleepQ2") }}
                    <!--b. Ongoing chronic Lack of sleep?  -->
                  </td>
                  <td class="dialog-input-field-right-alt border-dots-inner">
                    <label for="sec2FatigueChronicLackOfSleepYes">{{ $t("DQ.yes") }}</label>&nbsp;
                    <input type="radio" name="sec2FatigueChronicLackOfSleep" :value="true" v-model="input.sec2FatigueChronicLackOfSleep">
                    &nbsp;
                    <label for="sec2FatigueChronicLackOfSleepNo">{{ $t("DQ.no") }}</label>&nbsp;
                    <input type="radio" name="sec2FatigueChronicLackOfSleep" :value="false" v-model="input.sec2FatigueChronicLackOfSleep">
                  </td>
                </tr>
              </table>
            </td>
          </tr>

          <tr>
            <!-- d. Do you go to sleep within an hour of the same time each night? -->
            <td class="dialog-question-space">

            </td>
            <td colspan="2" class="dialog-sub-question border-dots-inner">
              <table style="width:100%" border="0">      
                <tr>
                  <td class="dialog-question-space">
                  </td>
                  <td class="dialog-sub-question border-dots-inner">
                    {{ $t("DQ.s2QSleepQ4") }}
                    <!--d. Do you go to sleep within an hour of the same time each night?  -->
                  </td>
                  <td class="dialog-input-field-right border-dots-inner">
                    <label for="sec3FatigueSleepSameTimeYes">{{ $t("DQ.yes") }}</label>&nbsp;
                    <input type="radio" name="sec3FatigueSleepSameTime" :value="true" v-model="input.sec3FatigueSleepSameTime">
                    &nbsp;
                    <label for="sec3FatigueSleepSameTimeNo">{{ $t("DQ.no") }}</label>&nbsp;
                    <input type="radio" name="sec3FatigueSleepSameTime" :value="false" v-model="input.sec3FatigueSleepSameTime">
                  </td>
                </tr>
              </table>
            </td>
          </tr>

          <tr>
            <!-- e. Do you use a CPAP (Continuous Positive Airway Pressure device)? -->
            <td class="dialog-question-space-alt">

            </td>
            <td colspan="2" class="dialog-sub-question-alt border-dots-inner">
              <table style="width:100%" border="0">      
                <tr>
                  <td class="dialog-question-space-alt">
                  </td>
                  <td class="dialog-sub-question-alt border-dots-inner">
                    {{ $t("DQ.s2QSleepQ5") }}
                    <!--e. Do you use a CPAP (Continuous Positive Airway Pressure device)?  -->
                  </td>
                  <td class="dialog-input-field-right-alt border-dots-inner">
                    <label for="sec3FatigueUseCPAPYes">{{ $t("DQ.yes") }}</label>&nbsp;
                    <input type="radio" name="sec3FatigueUseCPAP" :value="true" v-model="input.sec3FatigueUseCPAP">
                    &nbsp;
                    <label for="sec3FatigueUseCPAPNo">{{ $t("DQ.no") }}</label>&nbsp;
                    <input type="radio" name="sec3FatigueUseCPAP" :value="false" v-model="input.sec3FatigueUseCPAP"
                    @click="onSec3FatigueUseCPAP">
                  </td>
                </tr>
              </table>
            </td>
          </tr>

          <tr v-if="input.sec3FatigueUseCPAP == true">
            <!-- e-1. Did you use your CPAP the last time you slept? -->
            <td class="dialog-question-space">

            </td>
            <td colspan="2" class="dialog-sub-question">
              <table style="width:100%" border="0">      
                <tr>
                  <td class="dialog-question-space">
                  </td>
                  <td class="dialog-question-space">
                  </td>
                  <td class="dialog-sub-question border-dots-inner">
                    {{ $t("DQ.s2QSleepQ6") }}
                    <!--e-1. Did you use your CPAP the last time you slept? -->
                  </td>
                  <td class="dialog-input-field-right border-dots border-dots-inner">
                    <label for="sec3FatigueUseCPAPDuringLastSleepYes">{{ $t("DQ.yes") }}</label>&nbsp;
                    <input type="radio" name="sec3FatigueUseCPAPDuringLastSleep" :value="true" v-model="input.sec3FatigueUseCPAPDuringLastSleep">
                    &nbsp;
                    <label for="sec3FatigueUseCPAPDuringLastSleepNo">{{ $t("DQ.no") }}</label>&nbsp;
                    <input type="radio" name="sec3FatigueUseCPAPDuringLastSleep" :value="false" v-model="input.sec3FatigueUseCPAPDuringLastSleep">
                  </td>
                </tr>
              </table>
            </td>
          </tr>

          <tr v-if="input.sec3FatigueUseCPAP == true">
            <!-- e-2. Are you required by a physician to use your CPAP? -->
            <td class="dialog-question-space-alt">

            </td>
            <td colspan="2" class="dialog-sub-question-alt">
              <table style="width:100%" border="0">      
                <tr>
                  <td class="dialog-question-space-alt">
                  </td>
                  <td class="dialog-question-space-alt">
                  </td>
                  <td class="dialog-sub-question-alt border-dots-inner">
                    {{ $t("DQ.s2QSleepQ7") }}
                    <!--e-2. Are you required by a physician to use your CPAP?  -->
                  </td>
                  <td class="dialog-input-field-right-alt border-dots border-dots-inner">
                    <label for="sec3FatigueCPAPRequiredYes">{{ $t("DQ.yes") }}</label>&nbsp;
                    <input type="radio" name="sec3FatigueCPAPRequired" :value="true" v-model="input.sec3FatigueCPAPRequired">
                    &nbsp;
                    <label for="sec3FatigueCPAPRequiredNo">{{ $t("DQ.no") }}</label>&nbsp;
                    <input type="radio" name="sec3FatigueCPAPRequired" :value="false" v-model="input.sec3FatigueCPAPRequired">
                  </td>
                </tr>
              </table>
            </td>
          </tr>

          <tr>
            <!-- EMOTION -->
            <td class="dialog-question-space border-dots">

            </td>
            <td class="dialog-sub-question border-dots-inner" colspan="1">             
              {{ $t("DQ.s2QEmotion") }}
              <!-- "7. Emotion – Have you experienced any traumatic personal or work events recently?-->
            </td>
            <td class="dialog-input-field-right border-dots border-dots-inner" colspan="2">
              <label for="sec2EmotionRecentTraumaYes">{{ $t("DQ.yes") }}</label>&nbsp;
              <input type="radio" name="sec2EmotionRecentTrauma" :value="true" v-model="input.sec2EmotionRecentTrauma">
              &nbsp;
              <label for="sec2EmotionRecentTraumaNo">{{ $t("DQ.no") }}</label>&nbsp;
              <input type="radio" name="sec2EmotionRecentTrauma" :value="false" v-model="input.sec2EmotionRecentTrauma"
              @click="onSec2EmotionRecentTrauma">
            </td>
          </tr>

          <tr v-if="input.sec2EmotionRecentTrauma == true">
            <!-- FATIGUE - EXPLAIN-->
            <td class="dialog-question-space-alt">

            </td>
            <td colspan="2" class="dialog-sub-question-alt border-dots-inner">
              <table style="width:100%" border="0">           
                <tr>
                  <td class="dialog-question-space-alt">
                  </td>
                  <td>    
                    {{ $t("DQ.ifYesExplain") }}
                    <!-- If yes then please explain:-->  
                  </td>
                  <td class="dialog-input-field-explain border-dots border-dots-inner"> 
                    <textarea name="sec2EmotionExplanation" 
                      cols=2
                      style="width:100%;resize: none;height:100%;border-radius:5px;"
                      v-model="input.sec2EmotionExplanation"
                      v-bind:placeholder="$t('DQ.explain')" 
                      maxlength="500"
                    />
                  </td>
                </tr>
              </table>   
            </td>
          </tr>

          <tr>
            <td colspan="3" class="radius-bottom-left-field-top radius-bottom-left-field-bottom radius-bottom-right-field-top radius-bottom-right-field-bottom" style="background-color:#343F68">
              <div style="height:15px;"></div>
            </td>
          </tr>
          <!--<tr>
            <td class="dialog-question-space radius-bottom-left-field-bottom radius-bottom-left-field-top">
            </td>
            <td class="dialog-sub-question">
            </td>
            <td class="section-footer radius-bottom-right-field-top radius-bottom-right-field-bottom" > 
            </td>
          </tr>-->
          <!-- 
            ***************************************************
            *        SECTION 3 - MEDICAL WELLNESS             *
            ***************************************************
          -->
          <div style="height:10px;"></div>
          <tr>
            <td class="dialog-signon-td-section-title radius-top-left-field-top radius-top-left-field-bottom radius-top-right-field-top radius-top-right-field-bottom" colspan="3">
              
              <p> {{ $t("DQ.s3Title") }}</p><!--SECTION 5. - MEDICAL WELLNESS-->
              <!--"MEDICAL WELLNESS"-->
            </td>
          </tr>
          <tr>
            <td colspan="2" class="dialog-question border-dots-inner">
              <div style="height:20px;"></div>
              <p class="wrap"> {{ $t("DQ.s3FeelingToday") }}</p>
              <!--How are you feeling today? (Early intervention will give you the best chance to minimize disability.)-->
            </td>
            
            <td class="dialog-input-field-right border-dots">
              <label for="feelingTodayFine">{{ $t("DQ.s3FeelingTodayTotallyFine")  }}<!--"Totally Fine"--></label>&nbsp;
              <input type="radio" name="feelingTodayFine" :value="false" v-model="input.sec3MentalHealthFeelingToday">
              &nbsp;
              <label for="feelingTodayNotGreat">{{ $t("DQ.s3FeelingTodayNotGreat") }}<!--"Not Great"--></label>&nbsp;
              <input type="radio" name="feelingTodayNotGreat" :value="true" v-model="input.sec3MentalHealthFeelingToday"
              @click="onfeelingTodayFine">
            </td>
          </tr>
          <tr v-if="input.sec3MentalHealthFeelingToday == true">
            <td class="dialog-question-space ">

            </td>
            <td class="dialog-sub-question border-dots-inner" colspan="1">             
              {{ $t("DQ.s3FeelingTodayWeeks") }}
              <!--1.	Have you experienced any Anxiety and or Depression over the past 2 weeks?-->
            </td>
            <td class="dialog-input-field-right border-dots" colspan="2">
              <label for="MH1FeelingTodayWeeksYes">{{ $t("DQ.yes") }}</label>&nbsp;
              <input type="radio" name="MH1FeelingTodayWeeksYes" :value="true" v-model="input.sec3MentalHealthPast2Weeks">
              &nbsp;
              <label for="MH1FeelingTodayWeeksNo">{{ $t("DQ.no") }}</label>&nbsp;
              <input type="radio" name="MH1FeelingTodayWeeksNo" :value="false" v-model="input.sec3MentalHealthPast2Weeks"
              @click="onMH1FeelingTodayWeeks">
            </td>
          </tr>

          <tr v-if="input.sec3MentalHealthFeelingToday == true && input.sec3MentalHealthPast2Weeks == true">
            <td class="dialog-question-space-alt border-dots-inner" colspan="1">

            </td>
            <td class="dialog-sub-question-alt border-dots-inner">
              <table style="width:100%" border="0">           
                <tr>
                  <td>
                    <div class="dialog-sub-question-div" style="width:25px;" />
                  </td>
                  <td style="width:100%">           
                    {{ $t("DQ.s3AnxietyQ1") }}
                    <!--"a. Feeling nervous, anxious or on edge."-->
                  </td>
                </tr>
              </table>
            </td>
            <td id="MH1FeelingTodayWeeksNervousAnxious" class="dialog-input-field-right-alt border-dots"> 
              <select name="sec3MentalHealthNervouseAnxious" 
                      v-model="input.sec3MentalHealthNervouseAnxious">
                <option value=0>{{ $t("DQ.selectOne") }}</option>
                <option value=1>{{ $t("DQ.notAtAll") }}</option>
                <option value=2>{{ $t("DQ.serveralDays") }}</option>
                <option value=3>{{ $t("DQ.moreThanHalfTheDays") }}</option>               
                <option value=4>{{ $t("DQ.nearlyEveryday") }}</option>
              </select>
            </td>
          </tr>

          <tr v-if="input.sec3MentalHealthFeelingToday == true && input.sec3MentalHealthPast2Weeks == true">
            <td class="dialog-question-space border-dots-inner" colspan="1">

            </td>
            <td class="dialog-sub-question border-dots-inner"> 
              <table style="width:100%" border="0">           
                <tr>
                  <td>
                    <div class="dialog-sub-question-div" style="width:25px;" />
                  </td>
                  <td style="width:100%">                   
                    {{ $t("DQ.s3AnxietyQ2") }}
                    <!--"b. Not being able to stop or control worrying."-->
                  </td>
                </tr>
              </table>
            </td>
            <td id="MH1FeelingTodayWeeksWorrying" class="dialog-input-field-right border-dots"> 
              <select name="sec3MentalHealthWorrying" 
                      v-model="input.sec3MentalHealthWorrying">
                <option value=0>{{ $t("DQ.selectOne") }}</option>
                <option value=1>{{ $t("DQ.notAtAll") }}</option>
                <option value=2>{{ $t("DQ.serveralDays") }}</option>
                <option value=3>{{ $t("DQ.moreThanHalfTheDays") }}</option>               
                <option value=4>{{ $t("DQ.nearlyEveryday") }}</option>
              </select>
            </td>
          </tr>

          <tr v-if="input.sec3MentalHealthFeelingToday == true && input.sec3MentalHealthPast2Weeks == true">
            <td class="dialog-question-space-alt border-dots-inner" colspan="1">

            </td>
            <td class="dialog-sub-question-alt border-dots-inner"> 
              <table style="width:100%" border="0">           
                <tr>
                  <td>
                    <div class="dialog-sub-question-div" style="width:25px;" />
                  </td>
                  <td style="width:100%">                   
                    {{ $t("DQ.s3AnxietyQ3") }}
                    <!--"c. Little interest or pleasure in doing things"-->
                  </td>
                </tr>
              </table>
            </td>
            <td id="sec3MentalHealthNoInterest" class="dialog-input-field-right-alt border-dots"> 
              <select name="sec3MentalHealthNoInterest" 
                      v-model="input.sec3MentalHealthNoInterest">
                <option value=0>{{ $t("DQ.selectOne") }}</option>
                <option value=1>{{ $t("DQ.notAtAll") }}</option>
                <option value=2>{{ $t("DQ.serveralDays") }}</option>
                <option value=3>{{ $t("DQ.moreThanHalfTheDays") }}</option>               
                <option value=4>{{ $t("DQ.nearlyEveryday") }}</option>
              </select>
            </td>
          </tr>

          <tr v-if="input.sec3MentalHealthFeelingToday == true && input.sec3MentalHealthPast2Weeks == true">
            <td class="dialog-question-space border-dots-inner" colspan="1">

            </td>
            <td class="dialog-sub-question border-dots-inner">  
              <table style="width:100%" border="0">           
                <tr>
                  <td>
                    <div class="dialog-sub-question-div" style="width:25px;" />
                  </td>
                  <td style="width:100%">  
                    {{ $t("DQ.s3AnxietyQ4") }}
                    <!--"c. Feeling down, depressed, or hopeless."-->
                  </td>
                </tr>
              </table>
            </td>
            <td id="MH1FeelingTodayWeeksDepression" class="dialog-input-field-right border-dots"> 
              <select name="sec3MentalHealthDepressed" 
                      v-model="input.sec3MentalHealthDepressed">
                <option value=0>{{ $t("DQ.selectOne") }}</option>
                <option value=1>{{ $t("DQ.notAtAll") }}</option>
                <option value=2>{{ $t("DQ.serveralDays") }}</option>
                <option value=3>{{ $t("DQ.moreThanHalfTheDays") }}</option>               
                <option value=4>{{ $t("DQ.nearlyEveryday") }}</option>
              </select>
            </td>
          </tr>

          <tr v-if="input.sec3MentalHealthFeelingToday == true && input.sec3MentalHealthPast2Weeks == true">
            <td class="dialog-question-space-alt border-dots-inner" colspan="1">

            </td>
            <td class="dialog-sub-question-alt border-dots-inner">   
              <table style="width:100%" border="0">           
                <tr>
                  <td>
                    <div class="dialog-sub-question-div" style="width:25px;" />
                  </td>
                  <td style="width:100%">  
                    {{ $t("DQ.s3AnxietyQ5") }}
                    <!--"d. Feeling Suicidal or Homicidal."-->
                  </td>
                </tr>
              </table>
            </td>
            <td id="MH1FeelingTodaySuicidalHomicidal" class="dialog-input-field-right-alt border-dots"> 
              <select name="sec3MentalHealthSuicidalHomicidal" 
                      v-model="input.sec3MentalHealthSuicidalHomicidal">
                <option value=0>{{ $t("DQ.selectOne") }}</option>
                <option value=1>{{ $t("DQ.notAtAll") }}</option>
                <option value=2>{{ $t("DQ.serveralDays") }}</option>
                <option value=3>{{ $t("DQ.moreThanHalfTheDays") }}</option>               
                <option value=4>{{ $t("DQ.nearlyEveryday") }}</option>
              </select>
              <br>
              <div style="height:10px" />
            </td>
          </tr>

          <tr v-if="input.sec3MentalHealthFeelingToday == true">
            <td class="dialog-question-space-alt">

            </td>
            <td class="dialog-sub-question-alt border-dots-inner" colspan="1">             
              {{ $t("DQ.s3DoctorOrders") }}
              <!--"2. Have you been following any/all of your doctor’s health recommendations?"-->
            </td>
            <td class="dialog-input-field-right-alt border-dots" colspan="2">
              <label for="sec3InstructionsFollowingDoctorOrdersYes">{{ $t("DQ.yes") }}</label>&nbsp;
              <input type="radio" name="sec3InstructionsFollowingDoctorOrders" :value="true" v-model="input.sec3InstructionsFollowingDoctorOrders">
              &nbsp;
              <label for="sec3InstructionsFollowingDoctorOrdersNo">{{ $t("DQ.no") }}</label>&nbsp;
              <input type="radio" name="sec3InstructionsFollowingDoctorOrders" :value="false" v-model="input.sec3InstructionsFollowingDoctorOrders">
            </td>
          </tr>

          <tr v-if="input.sec3MentalHealthFeelingToday == true">
            <!--3.	Do you need any Accommodations today?-->
            <td class="dialog-question-space">

            </td>
            <td class="dialog-sub-question border-dots-inner" colspan="1">             
              {{ $t("DQ.s3Accommodations") }}
              <!--3.	Do you need any Accommodations today?-->
            </td>
            <td class="dialog-input-field-right border-dots" colspan="2">
              <label for="MH5AccommodationsYes">{{ $t("DQ.yes") }}</label>&nbsp;
              <input type="radio" name="MH5AccommodationsYes" :value="true" v-model="input.sec3AccommodationNeeded">
              &nbsp;
              <label for="MH5AccommodationsNo">{{ $t("DQ.no") }}</label>&nbsp;
              <input type="radio" name="MH5AccommodationsNo" :value="false" v-model="input.sec3AccommodationNeeded"
              @click="onMH5Accommodations">
            </td>
          </tr>
          
          <tr v-if="input.sec3MentalHealthFeelingToday == true && input.sec3AccommodationNeeded == true">
            <td class="dialog-question-space-alt border-dots-inner" colspan="1">

            </td>
            <td class="dialog-sub-question-alt border-dots-inner">   
              <table style="width:100%" border="0">           
                <tr>
                  <td>
                    <div class="dialog-sub-question-div" style="width:25px;" />
                  </td>
                  <td style="width:100%">              
                    {{ $t("DQ.s3AccommodationsJobApplicationAdjustment") }}
                    <!--"a. Request an adjustments to the job application process so a qualified applicant with a disability can be considered for a position.-->
                  </td>
                </tr>
              </table>  
            </td>
            <td class="dialog-input-field-right-alt border-dots">
              <label for="MH5AccommodationsJobApplicationAdjustmentYes">{{ $t("DQ.yes") }}</label>&nbsp;
              <input type="radio" name="MH5AccommodationsJobApplicationAdjustmentYes" :value="true" v-model="input.sec3AccomodationJobAppAdjustment">
              &nbsp;
              <label for="MH5AccommodationsJobApplicationAdjustmentNo">{{ $t("DQ.no") }}</label>&nbsp;
              <input type="radio" name="MH5AccommodationsJobApplicationAdjustmentNo" :value="false" v-model="input.sec3AccomodationJobAppAdjustment">
            </td>
          </tr>

          <tr v-if="input.sec3MentalHealthFeelingToday == true && input.sec3AccommodationNeeded == true">
            <td class="dialog-question-space border-dots-inner" colspan="1">

            </td>
            <td class="dialog-sub-question border-dots-inner">    
              <table style="width:100%" border="0">           
                <tr>
                  <td>
                    <div class="dialog-sub-question-div" style="width:25px;" />
                  </td>
                  <td style="width:100%">              
                    {{ $t("DQ.s3AccommodationsWorkScheduleModification") }}
                    <!--b.  Request a modification to the physical work environment, or to the way a job is usually performed, so an individual with a disability can perform the essential functions of that position.-->
                  </td>
                </tr>
              </table> 
            </td>
            <td class="dialog-input-field-right border-dots">
              <label for="MH5AccommodationsWorkScheduleModificationYes">{{ $t("DQ.yes") }}</label>&nbsp;
              <input type="radio" name="MH5AccommodationsWorkScheduleModificationYes" :value="true" v-model="input.sec3AccommodationScheduleModification">
              &nbsp;
              <label for="MH5AccommodationsWorkScheduleModificationNo">{{ $t("DQ.no") }}</label>&nbsp;
              <input type="radio" name="MH5AccommodationsWorkScheduleModificationNo" :value="false" v-model="input.sec3AccommodationScheduleModification">
            </td>
          </tr>

          <tr v-if="input.sec3MentalHealthFeelingToday == true && input.sec3AccommodationNeeded == true">
            <td class="dialog-question-space-alt border-dots-inner" colspan="1">

            </td>
            <td class="dialog-sub-question-alt border-dots-inner">
               <table style="width:100%" border="0">           
                <tr>
                  <td>
                    <div class="dialog-sub-question-div" style="width:25px;" />
                  </td>
                  <td style="width:100%">             
                    {{ $t("DQ.s3AccommodationsEqualBenefitsChange") }}
                    <!--c. Request changes that enable an employee with a disability to enjoy equal benefits and privileges of employment like those that are enjoyed by other employees without disabilities. This may include access to cafeterias, lounges, auditoriums, and company-provided transportation.-->
                  </td>
                </tr>
              </table>   
            </td>
            <td class="dialog-input-field-right-alt border-dots">
              <label for="MH5AccommodationsEqualBenefitsChangeYes">{{ $t("DQ.yes") }}</label>&nbsp;
              <input type="radio" name="MH5AccommodationsEqualBenefitsChangeYes" :value="true" v-model="input.sec3AccommodationEqualBenefitsChange">
              &nbsp;
              <label for="MH5AccommodationsEqualBenefitsChangeNo">{{ $t("DQ.no") }}</label>&nbsp;
              <input type="radio" name="MH5AccommodationsEqualBenefitsChangeNo" :value="false" v-model="input.sec3AccommodationEqualBenefitsChange">
            </td>
          </tr>
          <tr v-if="input.sec3MentalHealthFeelingToday == true && input.sec3AccommodationNeeded == true">
            <td class="dialog-question-space border-dots-inner" colspan="1">

            </td>
            <td class="dialog-sub-question border-dots-inner">  
              <table style="width:100%" border="0">           
                <tr>
                  <td>
                    <div class="dialog-sub-question-div" style="width:25px;" />
                  </td>
                  <td style="width:100%">
                    {{ $t("DQ.s3AccommodationsDoctorsAppointment") }}
                    <!--d. Request a doctors appointment.-->
                  </td>
                </tr>
              </table>    
            </td>
            <td class="dialog-input-field-right border-dots">
              <label for="MH5AccommodationsDoctorsAppointmentYes">{{ $t("DQ.yes") }}</label>&nbsp;
              <input type="radio" name="MH5AccommodationsDoctorsAppointmentYes" :value="true" v-model="input.sec3AccommodationDoctorsAppointment">
              &nbsp;
              <label for="MH5AccommodationsDoctorsAppointmentNo">{{ $t("DQ.no") }}</label>&nbsp;
              <input type="radio" name="MH5AccommodationsDoctorsAppointmentNo" :value="false" v-model="input.sec3AccommodationDoctorsAppointment">
            </td>
          </tr>

          <tr v-if="input.sec3MentalHealthFeelingToday == true">
            <td class="dialog-question-space-alt">

            </td>
            <td class="dialog-sub-question-alt border-dots-inner" colspan="1">             
              {{ $t("DQ.s3Other") }}
              <!--"6.	Is something else bothering you today?"-->
            </td>
           
            <td class="dialog-input-field-right-alt border-dots">
              <label for="MH6OtherYes">{{ $t("DQ.yes") }}</label>&nbsp;
              <input type="radio" name="MH6OtherYes" :value="true" v-model="input.sec3OtherBotheringYou">
              &nbsp;
              <label for="MH6OtherNo">{{ $t("DQ.no") }}</label>&nbsp;
              <input type="radio" name="MH6OtherNo" :value="false" v-model="input.sec3OtherBotheringYou"
              @click="onMH6Other">
            </td>
          </tr>

          <tr v-if="input.sec3MentalHealthFeelingToday == true && input.sec3OtherBotheringYou == true">
            <td class="dialog-question-space border-dots-inner">

            </td>
            <td class="dialog-sub-question border-dots-inner">
               <table style="width:100%" border="0">           
                <tr>
                  <td>
                    <div class="dialog-sub-question-div" style="width:25px;" />
                  </td>
                  <td style="width:100%">  
                    <!-- IF YES THE EXPLAIN-->           
                    {{ $t("DQ.ifYesExplain") }}
                  </td>
                </tr>
              </table>   
            </td>
            <td class="dialog-input-field-explain border-dots"> 
              <textarea name="sec4PanContactWithC19DiagnosedPerson" 
                        cols=2
                        style="width:100%;resize: none;height:100%;border-radius:5px;"
                        v-model="input.sec3OtherExplanation"
                        v-bind:placeholder="$t('DQ.explain')" 
                        :disabled="!input.sec3OtherBotheringYou"
                        :class="input.sec3OtherBotheringYou ? 'enabled' : 'disabled'"
                        maxlength="500"
                        />
            </td>
          </tr> 
          
          <tr v-if="input.sec3MentalHealthFeelingToday == true">
            <!--"5. Please enter your temperature reading for today:"-->
            <td class="dialog-question-space ">

            </td>
            <td class="dialog-sub-question border-dots-inner" colspan="1">             
              {{ $t("DQ.s3Temperature") }}
              <!--"5. Please enter your temperature reading for today:"-->
            </td>
           
            <td class="dialog-input-field-right border-dots">
              <input type="number" 
                name="sec3TempValue" 
                v-model="input.sec3TempValue" 
                style="width:100px;border-radius:5px;" 
                placeholder="XXX.XX" 
                maxlength="6"
                min="0"
                max="999.99"
                onKeyPress="if(this.value.length==6) return false;"
                >
            </td>
          </tr>

          <tr v-if="input.sec3MentalHealthFeelingToday == true">
            <!--5-a. Have you had a temperature greater than 100.4 within the past 3 days?-->
            <td class="dialog-question-space-alt" colspan="1">

            </td>
            <td class="dialog-sub-question-alt border-dots-inner">
              <table style="width:100%" border="0">           
                <tr>
                  <td>
                    <div class="dialog-sub-question-div" style="width:25px;" />
                  </td>
                  <td style="width:100%">           
                    {{ $t("DQ.s3TemperatureQ1") }}
                    <!--5-a. Have you had a temperature greater than 100.4 within the past 3 days?-->
                  </td>
                </tr>
              </table>
            </td>
            <td id="temperaturePastNDaysYes" class="dialog-input-field-right-alt border-dots"> 
              <label for="temperaturePastNDaysYes">{{ $t("DQ.yes") }}</label>&nbsp;
              <input type="radio" name="temperaturePastNDaysYes" :value="true" v-model="input.sec3TempPastNDays">
              &nbsp;
              <label for="temperaturePastNDaysNo">{{ $t("DQ.no") }}</label>&nbsp;
              <input type="radio" name="temperaturePastNDaysNo" :value="false" v-model="input.sec3TempPastNDays">
            </td>
          </tr>

          <tr v-if="input.sec3MentalHealthFeelingToday == true">
            <!--5-b. Did you use a digital thermometer?-->
            <td class="dialog-question-space">

            </td>
            <td class="dialog-sub-question border-dots-inner">
              <table style="width:100%" border="0">           
                <tr>
                  <td>
                    <div class="dialog-sub-question-div" style="width:25px;" />
                  </td>
                  <td style="width:100%">           
                    {{ $t("DQ.s3TemperatureQ2") }}
                    <!--5-b. Did you use a digital thermometer?-->
                  </td>
                </tr>
              </table>
            </td>
            <td id="usedDigitalThermometerYes" class="dialog-input-field-right border-dots-inner"> 
              <label for="usedDigitalThermometerYes">{{ $t("DQ.yes") }}</label>&nbsp;
              <input type="radio" name="usedDigitalThermometerYes" :value="true" v-model="input.sec3TempUsedDigitalThermometer">
              &nbsp;
              <label for="usedDigitalThermometerNo">{{ $t("DQ.no") }}</label>&nbsp;
              <input type="radio" name="usedDigitalThermometerNo" :value="false" v-model="input.sec3TempUsedDigitalThermometer">
            </td>
          </tr>

          <tr v-if="input.sec3MentalHealthFeelingToday == true">
            <td class="dialog-question-space-alt">

            </td>
            <td colspan="2" class="dialog-sub-question-alt border-dots-inner">             
              {{ $t("DQ.s3Symptom") }}
              <!--Have you experienced any of the following symptoms within the past 10 days? (Check "Yes" to all that apply)-->
            </td>
          </tr>

          <tr v-if="input.sec3MentalHealthFeelingToday == true">
            <!--a. Wet cough - Productive (A cough that produces mucus or phlegm.)-->
            <td class="dialog-question-space">

            </td>
            <td class="dialog-sub-question border-dots-inner">
              <table style="width:100%" border="0">           
                <tr>
                  <td>
                    <div class="dialog-sub-question-div" style="width:25px;" />
                  </td>
                  <td style="width:100%">           
                    {{ $t("DQ.s3SymptomQ1") }}
                    <!--a. Wet cough - Productive (A cough that produces mucus or phlegm.)-->
                  </td>
                </tr>
              </table>
            </td>
            <td id="wetCoughProductive" class="dialog-input-field-right border-dots-inner"> 
              <label for="wetCoughProductiveYes">{{ $t("DQ.yes") }}</label>&nbsp;
              <input type="radio" name="wetCoughProductiveYes" :value="true" v-model="input.sec3SymptomWetCoughProductive">
              &nbsp;
              <label for="wetCoughProductiveNo">{{ $t("DQ.no") }}</label>&nbsp;
              <input type="radio" name="wetCoughProductiveNo" :value="false" v-model="input.sec3SymptomWetCoughProductive">            
            </td>
          </tr>

          <tr v-if="input.sec3MentalHealthFeelingToday == true">
            <!--b. Wet cough - Non-productive (Does not bring up any mucus or phlegm.)-->
            <td class="dialog-question-space-alt">

            </td>
            <td class="dialog-sub-question-alt border-dots-inner">
              <table style="width:100%" border="0">           
                <tr>
                  <td>
                    <div class="dialog-sub-question-div" style="width:25px;" />
                  </td>
                  <td style="width:100%">           
                    {{ $t("DQ.s3SymptomQ2") }}
                    <!--b. Wet cough - Non-productive (Does not bring up any mucus or phlegm.)-->
                  </td>
                </tr>
              </table>
            </td>
            <td id="wetCoughNonProductive" class="dialog-input-field-right-alt border-dots-inner"> 
              <label for="wetCoughNonProductiveYes">{{ $t("DQ.yes") }}</label>&nbsp;
              <input type="radio" name="wetCoughNonProductiveYes" :value="true" v-model="input.sec3SymptomWetCoughNonProductive">
              &nbsp;
              <label for="wetCoughNonProductiveNo">{{ $t("DQ.no") }}</label>&nbsp;
              <input type="radio" name="wetCoughNonProductiveNo" :value="false" v-model="input.sec3SymptomWetCoughNonProductive">
            </td>
          </tr>

          <tr v-if="input.sec3MentalHealthFeelingToday == true">
            <!--c.  Dry cough - (Does not bring up any mucus or phlegm.)-->
            <td class="dialog-question-space">

            </td>
            <td class="dialog-sub-question border-dots-inner">
              <table style="width:100%" border="0">           
                <tr>
                  <td>
                    <div class="dialog-sub-question-div" style="width:25px;" />
                  </td>
                  <td style="width:100%">           
                    {{ $t("DQ.s3SymptomQ3") }}
                    <!--c.  Dry cough - (Does not bring up any mucus or phlegm.)-->
                  </td>
                </tr>
              </table>
            </td>
            <td id="dryCough" class="dialog-input-field-right border-dots-inner"> 
              <label for="dryCoughYes">{{ $t("DQ.yes") }}</label>&nbsp;
              <input type="radio" name="dryCoughYes" :value="true" v-model="input.sec3SymptomDryCough">
              &nbsp;
              <label for="dryCoughNo">{{ $t("DQ.no") }}</label>&nbsp;
              <input type="radio" name="dryCoughNo" :value="false" v-model="input.sec3SymptomDryCough">
            </td>
          </tr>

          <tr v-if="input.sec3MentalHealthFeelingToday == true">
            <!--d.  Sore throat-->
            <td class="dialog-question-space-alt">

            </td>
            <td class="dialog-sub-question-alt border-dots-inner">
              <table style="width:100%" border="0">           
                <tr>
                  <td>
                    <div class="dialog-sub-question-div" style="width:25px;" />
                  </td>
                  <td style="width:100%">           
                    {{ $t("DQ.s3SymptomQ4") }}
                    <!--d. Sore throat-->
                  </td>
                </tr>
              </table>
            </td>
            <td id="soreThroat" class="dialog-input-field-right-alt border-dots-inner"> 
              <label for="soreThroatYes">{{ $t("DQ.yes") }}</label>&nbsp;
              <input type="radio" name="soreThroatYes" :value="true" v-model="input.sec3SymptomSoreThroat">
              &nbsp;
              <label for="soreThroatNo">{{ $t("DQ.no") }}</label>&nbsp;
              <input type="radio" name="soreThroatNo" :value="false" v-model="input.sec3SymptomSoreThroat">
            </td>
          </tr>

          <tr v-if="input.sec3MentalHealthFeelingToday == true">
            <!--e. Congestion and/or running nose (Not related to seasonal allergies.)-->
            <td class="dialog-question-space">

            </td>
            <td class="dialog-sub-question border-dots-inner">
              <table style="width:100%" border="0">           
                <tr>
                  <td>
                    <div class="dialog-sub-question-div" style="width:25px;" />
                  </td>
                  <td style="width:100%">           
                    {{ $t("DQ.s3SymptomQ5") }}
                    <!--e. Congestion and/or running nose (Not related to seasonal allergies.)-->
                  </td>
                </tr>
              </table>
            </td>
            <td id="congestionRunningNose" class="dialog-input-field-right border-dots-inner"> 
              <label for="congestionRunningNoseYes">{{ $t("DQ.yes") }}</label>&nbsp;
              <input type="radio" name="congestionRunningNoseYes" :value="true" v-model="input.sec3SymptomCongestionRunningNose">
              &nbsp;
              <label for="congestionRunningNoseNo">{{ $t("DQ.no") }}</label>&nbsp;
              <input type="radio" name="congestionRunningNoseNo" :value="false" v-model="input.sec3SymptomCongestionRunningNose">
            </td>
          </tr>

          <tr v-if="input.sec3MentalHealthFeelingToday == true">
            <!--f. Shortness of breath-->
            <td class="dialog-question-space-alt">

            </td>
            <td class="dialog-sub-question-alt border-dots-inner">
              <table style="width:100%" border="0">           
                <tr>
                  <td>
                    <div class="dialog-sub-question-div" style="width:25px;" />
                  </td>
                  <td style="width:100%">           
                    {{ $t("DQ.s3SymptomQ6") }}
                    <!--f. Shortness of breath-->
                  </td>
                </tr>
              </table>
            </td>
            <td id="shortnessOfBreath" class="dialog-input-field-right-alt border-dots-inner"> 
              <label for="shortnessOfBreathYes">{{ $t("DQ.yes") }}</label>&nbsp;
              <input type="radio" name="shortnessOfBreathYes" :value="true" v-model="input.sec3SymptomShortnessOfBreath">
              &nbsp;
              <label for="shortnessOfBreathNo">{{ $t("DQ.no") }}</label>&nbsp;
              <input type="radio" name="shortnessOfBreathNo" :value="false" v-model="input.sec3SymptomShortnessOfBreath">
            </td>
          </tr>

          <tr v-if="input.sec3MentalHealthFeelingToday == true">
            <!--g. Chills-->
            <td class="dialog-question-space">

            </td>
            <td class="dialog-sub-question border-dots-inner">
              <table style="width:100%" border="0">           
                <tr>
                  <td>
                    <div class="dialog-sub-question-div" style="width:25px;" />
                  </td>
                  <td style="width:100%">           
                    {{ $t("DQ.s3SymptomQ7") }}
                    <!--g. Chills-->
                  </td>
                </tr>
              </table>
            </td>
            <td id="chills" class="dialog-input-field-right border-dots-inner"> 
              <label for="chillsYes">{{ $t("DQ.yes") }}</label>&nbsp;
              <input type="radio" name="chillsYes" :value="true" v-model="input.sec3SymptomChills">
              &nbsp;
              <label for="chillsNo">{{ $t("DQ.no") }}</label>&nbsp;
              <input type="radio" name="chillshNo" :value="false" v-model="input.sec3SymptomChills">
            </td>
          </tr>

          <tr v-if="input.sec3MentalHealthFeelingToday == true">
            <!--h. Headache-->
            <td class="dialog-question-space-alt">

            </td>
            <td class="dialog-sub-question-alt border-dots-inner">
              <table style="width:100%" border="0">           
                <tr>
                  <td>
                    <div class="dialog-sub-question-div" style="width:25px;" />
                  </td>
                  <td style="width:100%">           
                    {{ $t("DQ.s3SymptomQ8") }}
                    <!--h. Headache-->
                  </td>
                </tr>
              </table>
            </td>
            <td id="headache" class="dialog-input-field-right-alt border-dots-inner"> 
              <label for="headacheYes">{{ $t("DQ.yes") }}</label>&nbsp;
              <input type="radio" name="headacheYes" :value="true" v-model="input.sec3SymptomHeadache">
              &nbsp;
              <label for="headacheNo">{{ $t("DQ.no") }}</label>&nbsp;
              <input type="radio" name="headacheNo" :value="false" v-model="input.sec3SymptomHeadache">
            </td>
          </tr>

          <tr v-if="input.sec3MentalHealthFeelingToday == true">
            <!--i. Loss of smell-->
            <td class="dialog-question-space">

            </td>
            <td class="dialog-sub-question border-dots-inner">
              <table style="width:100%" border="0">           
                <tr>
                  <td>
                    <div class="dialog-sub-question-div" style="width:25px;" />
                  </td>
                  <td style="width:100%">           
                    {{ $t("DQ.s3SymptomQ9") }}
                    <!--i. Loss of smell-->
                  </td>
                </tr>
              </table>
            </td>
            <td id="lossOfSmell" class="dialog-input-field-right border-dots-inner"> 
              <label for="lossOfSmellYes">{{ $t("DQ.yes") }}</label>&nbsp;
              <input type="radio" name="lossOfSmellYes" :value="true" v-model="input.sec3SymptomLossOfSmell">
              &nbsp;
              <label for="lossOfSmellNo">{{ $t("DQ.no") }}</label>&nbsp;
              <input type="radio" name="lossOfSmellNo" :value="false" v-model="input.sec3SymptomLossOfSmell">
            </td>
          </tr>

          <tr v-if="input.sec3MentalHealthFeelingToday == true">
            <!--j. Loss of taste-->
            <td class="dialog-question-space-alt">

            </td>
            <td class="dialog-sub-question-alt border-dots-inner">
              <table style="width:100%" border="0">           
                <tr>
                  <td>
                    <div class="dialog-sub-question-div" style="width:25px;" />
                  </td>
                  <td style="width:100%">           
                    {{ $t("DQ.s3SymptomQ10") }}
                    <!--j. Loss of taste-->
                  </td>
                </tr>
              </table>
            </td>
            <td id="lossOfTaste" class="dialog-input-field-right-alt border-dots-inner"> 
              <label for="lossOfTasteYes">{{ $t("DQ.yes") }}</label>&nbsp;
              <input type="radio" name="lossOfTasteYes" :value="true" v-model="input.sec3SymptomLossOfTaste">
              &nbsp;
              <label for="lossOfTasteNo">{{ $t("DQ.no") }}</label>&nbsp;
              <input type="radio" name="lossOfTasteNo" :value="false" v-model="input.sec3SymptomLossOfTaste">
            </td>
          </tr>

          <tr v-if="input.sec3MentalHealthFeelingToday == true">
            <!--k. Loss of appetite-->
            <td class="dialog-question-space">

            </td>
            <td class="dialog-sub-question border-dots-inner">
              <table style="width:100%" border="0">           
                <tr>
                  <td>
                    <div class="dialog-sub-question-div" style="width:25px;" />
                  </td>
                  <td style="width:100%">           
                    {{ $t("DQ.s3SymptomQ11") }}
                    <!--k. Loss of appetite-->
                  </td>
                </tr>
              </table>
            </td>
            <td id="ossOfAppetite" class="dialog-input-field-right border-dots-inner"> 
              <label for="lossOfAppetiteYes">{{ $t("DQ.yes") }}</label>&nbsp;
              <input type="radio" name="lossOfAppetiteYes" :value="true" v-model="input.sec3SymptomLossOfAppetite">
              &nbsp;
              <label for="lossOfTasteNo">{{ $t("DQ.no") }}</label>&nbsp;
              <input type="radio" name="lossOfAppetiteNo" :value="false" v-model="input.sec3SymptomLossOfAppetite">
            </td>
          </tr>

          <tr v-if="input.sec3MentalHealthFeelingToday == true">
            <!--l.  Red eyes (Not related to seasonal allergies.)-->
            <td class="dialog-question-space-alt">

            </td>
            <td class="dialog-sub-question-alt border-dots-inner">
              <table style="width:100%" border="0">           
                <tr>
                  <td>
                    <div class="dialog-sub-question-div" style="width:25px;" />
                  </td>
                  <td style="width:100%">           
                    {{ $t("DQ.s3SymptomQ12") }}
                    <!--l.  Red eyes (Not related to seasonal allergies.)-->
                  </td>
                </tr>
              </table>
            </td>
            <td id="pinkEye" class="dialog-input-field-right-alt border-dots-inner"> 
              <label for="pinkEyeYes">{{ $t("DQ.yes") }}</label>&nbsp;
              <input type="radio" name="pinkEyeYes" :value="true" v-model="input.sec3SymptomPinkEye">
              &nbsp;
              <label for="pinkEyeNo">{{ $t("DQ.no") }}</label>&nbsp;
              <input type="radio" name="pinkEyeNo" :value="false" v-model="input.sec3SymptomPinkEye">
            </td>
          </tr>

          <tr v-if="input.sec3MentalHealthFeelingToday == true">
            <!--m. Body aches muscle and/or joint pain-->
            <td class="dialog-question-space">

            </td>
            <td class="dialog-sub-question border-dots-inner">
              <table style="width:100%" border="0">           
                <tr>
                  <td>
                    <div class="dialog-sub-question-div" style="width:25px;" />
                  </td>
                  <td style="width:100%">           
                    {{ $t("DQ.s3SymptomQ13") }}
                    <!--m. Body aches muscle and/or joint pain-->
                  </td>
                </tr>
              </table>
            </td>
            <td id="bodyAchesMuscleJointPain" class="dialog-input-field-right border-dots-inner"> 
              <label for="bodyAchesMuscleJointPainYes">{{ $t("DQ.yes") }}</label>&nbsp;
              <input type="radio" name="bodyAchesMuscleJointPainYes" :value="true" v-model="input.sec3SymptomBodyAchesPain">
              &nbsp;
              <label for="bodyAchesMuscleJointPainNo">{{ $t("DQ.no") }}</label>&nbsp;
              <input type="radio" name="bodyAchesMuscleJointPainNo" :value="false" v-model="input.sec3SymptomBodyAchesPain">
            </td>
          </tr>

          <tr v-if="input.sec3MentalHealthFeelingToday == true">
            <!--n. Sudden confusion-->
            <td class="dialog-question-space-alt">

            </td>
            <td class="dialog-sub-question-alt border-dots-inner">
              <table style="width:100%" border="0">           
                <tr>
                  <td>
                    <div class="dialog-sub-question-div" style="width:25px;" />
                  </td>
                  <td style="width:100%">           
                    {{ $t("DQ.s3SymptomQ14") }}
                    <!--n. Sudden confusion-->
                  </td>
                </tr>
              </table>
            </td>
            <td id="suddenConfusion" class="dialog-input-field-right-alt border-dots-inner"> 
              <label for="suddenConfusionYes">{{ $t("DQ.yes") }}</label>&nbsp;
              <input type="radio" name="suddenConfusionYes" :value="true" v-model="input.sec3SymptomSuddenConfusion">
              &nbsp;
              <label for="suddenConfusionNo">{{ $t("DQ.no") }}</label>&nbsp;
              <input type="radio" name="suddenConfusionNo" :value="false" v-model="input.sec3SymptomSuddenConfusion">
            </td>
          </tr>

          <tr v-if="input.sec3MentalHealthFeelingToday == true">
            <!--o. Digestive symptoms including diarrhea-->
            <td class="dialog-question-space">

            </td>
            <td class="dialog-sub-question border-dots-inner">
              <table style="width:100%" border="0">           
                <tr>
                  <td>
                    <div class="dialog-sub-question-div" style="width:25px;" />
                  </td>
                  <td style="width:100%">           
                    {{ $t("DQ.s3SymptomQ15") }}
                    <!--o. Digestive symptoms including diarrhea-->
                  </td>
                </tr>
              </table>
            </td>
            <td id="digestiveSystem" class="dialog-input-field-right border-dots-inner"> 
              <label for="digestiveSystemYes">{{ $t("DQ.yes") }}</label>&nbsp;
              <input type="radio" name="digestiveSystemYes" :value="true" v-model="input.sec3SymptomDigestiveSystem">
              &nbsp;
              <label for="digestiveSystemNo">{{ $t("DQ.no") }}</label>&nbsp;
              <input type="radio" name="digestiveSystemNo" :value="false" v-model="input.sec3SymptomDigestiveSystem">
            </td>
          </tr>

          <tr v-if="input.sec3MentalHealthFeelingToday == true">
            <!--p. Fatigue (Unusual or excessive whole-body tiredness not relieved by sleep.)-->
            <td class="dialog-question-space-alt">

            </td>
            <td class="dialog-sub-question-alt border-dots-inner">
              <table style="width:100%" border="0">           
                <tr>
                  <td>
                    <div class="dialog-sub-question-div" style="width:25px;" />
                  </td>
                  <td style="width:100%">           
                    {{ $t("DQ.s3SymptomQ16") }}
                    <!--p. Fatigue (Unusual or excessive whole-body tiredness not relieved by sleep.)-->
                  </td>
                </tr>
              </table>
            </td>
            <td id="fatigue" class="dialog-input-field-right-alt border-dots-inner"> 
              <label for="fatigueYes">{{ $t("DQ.yes") }}</label>&nbsp;
              <input type="radio" name="fatigueYes" :value="true" v-model="input.sec3SymptomFatigue">
              &nbsp;
              <label for="fatigueNo">{{ $t("DQ.no") }}</label>&nbsp;
              <input type="radio" name="fatigueNo" :value="false" v-model="input.sec3SymptomFatigue">
            </td>
          </tr>

          <tr v-if="input.sec3MentalHealthFeelingToday == true">
            <!--q. Chest pain-->
            <td class="dialog-question-space">

            </td>
            <td class="dialog-sub-question border-dots-inner">
              <table style="width:100%" border="0">           
                <tr>
                  <td>
                    <div class="dialog-sub-question-div" style="width:25px;" />
                  </td>
                  <td style="width:100%">           
                    {{ $t("DQ.s3SymptomQ17") }}
                    <!--q. Chest pain-->
                  </td>
                </tr>
              </table>
            </td>
            <td id="chestPain" class="dialog-input-field-right border-dots-inner"> 
              <label for="chestPainYes">{{ $t("DQ.yes") }}</label>&nbsp;
              <input type="radio" name="chestPainYes" :value="true" v-model="input.sec3SymptomChestPain">
              &nbsp;
              <label for="chestPainNo">{{ $t("DQ.no") }}</label>&nbsp;
              <input type="radio" name="chestPainNo" :value="false" v-model="input.sec3SymptomChestPain">
            </td>
          </tr>

          <tr v-if="input.sec3MentalHealthFeelingToday == true">
            <!--r. When did you start to feel the symptoms?-->
            <td class="dialog-question-space-alt">

            </td>
            <td class="dialog-sub-question-alt border-dots-inner">
              <table style="width:100%" border="0">           
                <tr>
                  <td>
                    <div class="dialog-sub-question-div" style="width:25px;" />
                  </td>
                  <td style="width:100%">           
                    {{ $t("DQ.s3SymptomQ18") }}
                    <!--r. When did you start to feel the symptoms?-->
                  </td>
                </tr>
              </table>
            </td>
            <td id="symptomDate" class="dialog-input-field-right-alt border-dots-inner"> 
              {{ $t("DQ.s3date") }}
              <input type="date" style="border-radius:5px" v-model="input.sec3SymptomStartDate">
            </td>
          </tr>

          <tr>
            <td colspan="3" class="radius-bottom-left-field-top radius-bottom-left-field-bottom radius-bottom-right-field-top radius-bottom-right-field-bottom" style="background-color:#343F68">
              <div style="height:15px;"></div>
            </td>
          </tr>

          <!--<tr>
            <td class="dialog-question-space radius-bottom-left-field-bottom radius-bottom-left-field-top">
            </td>
            <td class="dialog-sub-question">
            </td>
            <td class="section-footer radius-bottom-right-field-top radius-bottom-right-field-bottom" > 
            </td>
          </tr>-->
          <!-- END SECTION 3 -->
          <div style="height:10px;"></div>

          <!-- 
            ***************************************************
            *        SECTION 4 - PANDEMIC INFORMATION         *
            ***************************************************
          -->

          <tr>
            <td class="dialog-signon-td-section-title radius-top-left-field-top radius-top-left-field-bottom radius-top-right-field-top radius-top-right-field-bottom" colspan="3" >
              <!-- SECTION 1 TITLE -->
              {{ $t("DQ.s4title") }}
            </td>
          </tr>
          <tr>
            <td class="dialog-question-space" colspan="3">
              <div style="height:20px" />
            </td>
          </tr>

          <tr>
            <td colspan="2" class="dialog-question border-dots-inner">
             <p class="wrap"> {{ $t("DQ.s4QC19Profile") }}</p>
             <!--Is your COVID-19 Profile information with us up to date?-->
            </td>
            
            <td class="dialog-input-field-right border-dots">
              <label for="sec4PanProfileUpToDateYes">{{ $t("DQ.yes")  }}<!--"Yes"--></label>&nbsp;
              <input type="radio" name="sec4PanProfileUpToDate" :value="true" v-model="input.sec4PanProfileUpToDate">
              &nbsp;
              <label for="sec4PanProfileUpToDateNo">{{ $t("DQ.noNotSure") }}<!--"Not Sure"--></label>&nbsp;
              <input type="radio" name="sec4PanProfileUpToDate" :value="false" v-model="input.sec4PanProfileUpToDate">

            </td>
          </tr>

          <tr v-if="input.sec4PanProfileUpToDate == false">
            <td colspan="2" class="dialog-question col4-width  border-dots-inner">
              <!--Are you currently diagnosed as positive (with antibody or nasal swab test) for COVID-19?-->
              <p class="wrap"> {{ $t("DQ.s4QC19ProfileQ1") }}</p>
            </td>
            <td class="dialog-input-field-right  border-dots" >
              
              <label for="sec4PanCurrentlyHaveC19Yes">{{ $t("DQ.yes") }}</label>&nbsp;
              <input type="radio" name="sec4PanCurrentlyHaveC19Yes" :value="true" v-model="input.sec4PanCurrentlyHaveC19">
              &nbsp;
              <label for="sec4PanCurrentlyHaveC19No">{{ $t("DQ.no") }}</label>&nbsp;
              <input type="radio" name="sec4PanCurrentlyHaveC19No" :value="false" v-model="input.sec4PanCurrentlyHaveC19">
            </td>
          </tr>
         
          <tr v-if="input.sec4PanProfileUpToDate == false">
            <td colspan="2" class="dialog-sub-question-alt  border-dots-inner">
              <!--Have you previously tested positive (with antibody or nasal swab test) for COVID-19?-->
              <p class="wrap"> {{ $t("DQ.s4QC19ProfileQ2") }}</p>
            </td>
            <td class="dialog-input-field-right-alt  border-dots" >
              <label for="previousTestedPositiveC19Yes">{{ $t("DQ.yes") }}</label>&nbsp;
              <input type="radio" name="previousTestedPositiveC19Yes" :value="true" v-model="input.sec4PanPrevTestedPositiveForC19">
              &nbsp;
              <label for="previousTestedPositiveC19No">{{ $t("DQ.no") }}</label>&nbsp;
              <input type="radio" name="previousTestedPositiveC19No" :value="false" v-model="input.sec4PanPrevTestedPositiveForC19"
              @click="onPreviousTestedPositiveC19">
            </td>
          </tr>

          <tr v-if="input.sec4PanProfileUpToDate == false">
            <td class="dialog-question-space" >

            </td>
            <td class="dialog-sub-question  border-dots-inner">
              <!-- At least 10 days have passed from the onset of symptoms and no subsequent illness. -->
              {{ $t("DQ.s4QC19ProfileQ2a") }}
            </td>
            <td class="dialog-input-field-right  border-dots">
              <label for="previousTestedPositiveC19AYes">{{ $t("DQ.yes") }}</label>&nbsp;
              <input type="radio" 
                     name="previousTestedPositiveC19AYes" 
                     :value="true"
                     v-model="input.sec4PanPrevTestedPositiveForC19A"
                     :disabled="!input.sec4PanPrevTestedPositiveForC19">
              &nbsp;
              <label for="previousTestedPositiveC19ANo">{{ $t("DQ.no") }}</label>&nbsp;
              <input type="radio" 
                     name="previousTestedPositiveC19ANo" 
                     :value="false"
                     v-model="input.sec4PanPrevTestedPositiveForC19A"
                     :disabled="!input.sec4PanPrevTestedPositiveForC19">
            </td>
          </tr>

          <tr v-if="input.sec4PanProfileUpToDate == false">
            <td class="dialog-question-space-alt">

            </td>
            <td class="dialog-sub-question-alt border-dots-inner">
              <!--  There have been 3 days without fever and without the use of fever reducing medications. -->
              {{ $t("DQ.s4QC19ProfileQ2b") }}
            </td>
            <td class="dialog-input-field-right-alt border-dots">
              <label for="previousTestedPositiveC19BYes">{{ $t("DQ.yes") }}</label>&nbsp;
              <input type="radio" 
                      name="previousTestedPositiveC19BYes" 
                      :value="true"
                      v-model="input.sec4PanPrevTestedPositiveForC19B"
                      :disabled="!input.sec4PanPrevTestedPositiveForC19">
              &nbsp;
              <label for="previousTestedPositiveC19BNo">{{ $t("DQ.no") }}</label>&nbsp;
              <input type="radio" 
                     name="previousTestedPositiveC19BNo" 
                     :value="false"
                     v-model="input.sec4PanPrevTestedPositiveForC19B"
                     :disabled="!input.sec4PanPrevTestedPositiveForC19">
            </td>
          </tr>

          <tr v-if="input.sec4PanProfileUpToDate == false">
            <td class="dialog-question-space">

            </td>
            <td class="dialog-sub-question border-dots-inner">
              <!--Respiratory symptoms: cough and/or shortness of breath have resolved.-->
              {{ $t("DQ.s4QC19ProfileQ2c") }}
            </td>
            <td class="dialog-input-field-right border-dots">
              <label for="previousTestedPositiveC19CYes">{{ $t("DQ.yes") }}</label>&nbsp;
              <input type="radio" 
                     name="previousTestedPositiveC19CYes" 
                     :value="true"
                     v-model="input.sec4PanPrevTestedPositiveForC19C"
                     :disabled="!input.sec4PanPrevTestedPositiveForC19">
              &nbsp;
              <label for="previousTestedPositiveC19CNo">{{ $t("DQ.no") }}</label>&nbsp;
              <input type="radio" 
                     name="previousTestedPositiveC19CNo" 
                     :value="false"
                     v-model="input.sec4PanPrevTestedPositiveForC19C"
                     :disabled="!input.sec4PanPrevTestedPositiveForC19">
            </td>
          </tr>

          <tr v-if="input.sec4PanProfileUpToDate == false">
            <td colspan="2" class="dialog-question border-dots-inner">
              <!--Have you had close or direct contact with a person diagnosed with COVID-19 in the past 14 days?-->
              <p class="wrap"> {{ $t("DQ.s4QC19ProfileQ3") }}</p>
            </td>
           <td class="dialog-input-field-right border-dots">
              <label for="contactWithC19DiagnosedPersonYes">{{ $t("DQ.yes") }}</label>&nbsp;
              <input type="radio" name="contactWithC19DiagnosedPersonYes" :value="true" v-model="input.sec4PanContactWithC19DiagnosedPerson">
              &nbsp;
              <label for="contactWithC19DiagnosedPersonNo">{{ $t("DQ.no") }}</label>&nbsp;
              <input type="radio" name="contactWithC19DiagnosedPersonNo" :value="false" v-model="input.sec4PanContactWithC19DiagnosedPerson"
              @click="onContactWithC19DiagnosedPerson">
            </td>
          </tr>

          <tr v-if="input.sec4PanProfileUpToDate == false && input.sec4PanContactWithC19DiagnosedPerson == true">
            <td class="dialog-question-space-alt">

            </td>
            <td class="dialog-sub-question-alt border-dots-inner" >
              <!-- IF YES THE EXPLAIN-->
              {{ $t("DQ.ifYesExplain") }}
            </td>

            <td class="dialog-input-field-explain-alt border-dots"> 
              <textarea name="sec4PanContactWithC19DiagnosedPerson" 
                        cols=2
                        style="width:100%;resize: none;height:100%;border-radius:5px;"
                        v-model="input.sec4PanContactWithC19DiagnosedPersonExplain"
                        v-bind:placeholder="$t('DQ.explain')" 
                        :disabled="!input.sec4PanContactWithC19DiagnosedPerson"
                        :class="input.sec4PanContactWithC19DiagnosedPerson ? 'enabled' : 'disabled'"
                        maxlength="500"
                        />
            </td>
          </tr> 

          <tr v-if="input.sec4PanProfileUpToDate == false">
            <td colspan="2" class="dialog-sub-question-alt border-dots-inner" >
              <!--Have you had close or direct contact with someone who has travelled to another country in the past 14 days?-->
              <p class="wrap"> {{ $t("DQ.s4QC19ProfileQ4") }}</p>
            </td>
            
            <td class="dialog-input-field-right-alt border-dots">
              <label for="contactWithC19TravelerYes">{{ $t("DQ.yes") }}</label>&nbsp;
              <input type="radio" name="contactWithC19TravelerYes" :value="true" v-model="input.sec4PanContactWithC19Traveler">
              &nbsp;
              <label for="contactWithC19TravelerNo">{{ $t("DQ.no") }}</label>&nbsp;
              <input type="radio" name="contactWithC19TravelerNo" :value="false" v-model="input.sec4PanContactWithC19Traveler"
              @click="onContactWithC19Traveler">
            </td>
          </tr>

          <tr v-if="input.sec4PanProfileUpToDate == false && input.sec4PanContactWithC19Traveler == true">
            <td class="dialog-question-space">

            </td>
            <td class="dialog-sub-question border-dots-inner">
              <!--If yes, then please tell us what country:-->
              {{ $t("DQ.s4QC19ProfileQ4country") }}
            </td>
            <td id="country" class="dialog-input-field-right"> 
              <select name="sec4PanContactWithC19TravelerCountryId" 
                      v-model="input.sec4PanContactWithC19TravelerCountryId"
                      :disabled="!input.sec4PanContactWithC19Traveler"
                      style="border-radius:5px;"
                      :class="input.sec4PanContactWithC19Traveler ? 'enabled' : 'disabled'">
                <option value="0">Select-one</option>
                <option value="1">Afghanistan</option>
                <option value="2">Ã…land Islands</option>
                <option value="3">Albania</option>
                <option value="4">Algeria</option>
                <option value="5">American Samoa</option>
                <option value="6">Andorra</option>
                <option value="7">Angola</option>
                <option value="8">Anguilla</option>
                <option value="9">Antarctica</option>
                <option value="10">Antigua and Barbuda</option>
                <option value="11">Argentina</option>
                <option value="12">Armenia</option>
                <option value="13">Aruba</option>
                <option value="14">Australia</option>
                <option value="15">Austria</option>
                <option value="16">Azerbaijan</option>
                <option value="17">Bahamas</option>
                <option value="18">Bahrain</option>
                <option value="19">Bangladesh</option>
                <option value="20">Barbados</option>
                <option value="21">Belarus</option>
                <option value="22">Belgium</option>
                <option value="23">Belize</option>
                <option value="24">Benin</option>
                <option value="25">Bermuda</option>
                <option value="26">Bhutan</option>
                <option value="27">Bolivia, Plurinational State of</option>
                <option value="28">Bonaire, Sint Eustatius and Saba</option>
                <option value="29">Bosnia and Herzegovina</option>
                <option value="30">Botswana</option>
                <option value="31">Bouvet Island</option>
                <option value="32">Brazil</option>
                <option value="33">British Indian Ocean Territory</option>
                <option value="34">Brunei Darussalam</option>
                <option value="35">Bulgaria</option>
                <option value="36">Burkina Faso</option>
                <option value="37">Burundi</option>
                <option value="38">Cambodia</option>
                <option value="39">Cameroon</option>
                <option value="40">Canada</option>
                <option value="41">Cape Verde</option>
                <option value="42">Cayman Islands</option>
                <option value="43">Central African Republic</option>
                <option value="44">Chad</option>
                <option value="45">Chile</option>
                <option value="46">China</option>
                <option value="47">Christmas Island</option>
                <option value="48">Cocos (Keeling) Islands</option>
                <option value="49">Colombia</option>
                <option value="50">Comoros</option>
                <option value="51">Congo</option>
                <option value="52">Congo, the Democratic Republic of the</option>
                <option value="53">Cook Islands</option>
                <option value="54">Costa Rica</option>
                <option value="55">CÃ´te d`Ivoire</option>
                <option value="56">Croatia</option>
                <option value="57">Cuba</option>
                <option value="58">CuraÃ§ao</option>
                <option value="59">Cyprus</option>
                <option value="60">Czech Republic</option>
                <option value="61">Denmark</option>
                <option value="62">Djibouti</option>
                <option value="63">Dominica</option>
                <option value="64">Dominican Republic</option>
                <option value="65">Ecuador</option>
                <option value="66">Egypt</option>
                <option value="67">El Salvador</option>
                <option value="68">Equatorial Guinea</option>
                <option value="69">Eritrea</option>
                <option value="70">Estonia</option>
                <option value="71">Ethiopia</option>
                <option value="72">Falkland Islands (Malvinas)</option>
                <option value="73">Faroe Islands</option>
                <option value="74">Fiji</option>
                <option value="75">Finland</option>
                <option value="76">France</option>
                <option value="77">French Guiana</option>
                <option value="78">French Polynesia</option>
                <option value="79">French Southern Territories</option>
                <option value="80">Gabon</option>
                <option value="81">Gambia</option>
                <option value="82">Georgia</option>
                <option value="83">Germany</option>
                <option value="84">Ghana</option>
                <option value="85">Gibraltar</option>
                <option value="86">Greece</option>
                <option value="87">Greenland</option>
                <option value="88">Grenada</option>
                <option value="89">Guadeloupe</option>
                <option value="90">Guam</option>
                <option value="91">Guatemala</option>
                <option value="92">Guernsey</option>
                <option value="93">Guinea</option>
                <option value="94">Guinea-Bissau</option>
                <option value="95">Guyana</option>
                <option value="96">Haiti</option>
                <option value="97">Heard Island and McDonald Islands</option>
                <option value="98">Holy See (Vatican City State)</option>
                <option value="99">Honduras</option>
                <option value="100">Hong Kong</option>
                <option value="101">Hungary</option>
                <option value="102">Iceland</option>
                <option value="103">India</option>
                <option value="104">Indonesia</option>
                <option value="105">Iran, Islamic Republic of</option>
                <option value="106">Iraq</option>
                <option value="107">Ireland</option>
                <option value="108">Isle of Man</option>
                <option value="109">Israel</option>
                <option value="110">Italy</option>
                <option value="111">Jamaica</option>
                <option value="112">Japan</option>
                <option value="113">Jersey</option>
                <option value="114">Jordan</option>
                <option value="115">Kazakhstan</option>
                <option value="116">Kenya</option>
                <option value="117">Kiribati</option>
                <option value="118">Korea, Democratic People`s Republic of</option>
                <option value="119">Korea, Republic of</option>
                <option value="120">Kuwait</option>
                <option value="121">Kyrgyzstan</option>
                <option value="122">Lao People`s Democratic Republic</option>
                <option value="123">Latvia</option>
                <option value="124">Lebanon</option>
                <option value="125">Lesotho</option>
                <option value="126">Liberia</option>
                <option value="127">Libya</option>
                <option value="128">Liechtenstein</option>
                <option value="129">Lithuania</option>
                <option value="130">Luxembourg</option>
                <option value="131">Macao</option>
                <option value="133">Madagascar</option>
                <option value="134">Malawi</option>
                <option value="135">Malaysia</option>
                <option value="136">Maldives</option>
                <option value="137">Mali</option>
                <option value="138">Malta</option>
                <option value="139">Marshall Islands</option>
                <option value="140">Martinique</option>
                <option value="141">Mauritania</option>
                <option value="142">Mauritius</option>
                <option value="143">Mayotte</option>
                <option value="144">Mexico</option>
                <option value="145">Micronesia, Federated States of</option>
                <option value="146">Moldova, Republic of</option>
                <option value="147">Monaco</option>
                <option value="148">Mongolia</option>
                <option value="149">Montenegro</option>
                <option value="150">Montserrat</option>
                <option value="151">Morocco</option>
                <option value="152">Mozambique</option>
                <option value="153">Myanmar</option>
                <option value="154">Namibia</option>
                <option value="155">Nauru</option>
                <option value="156">Nepal</option>
                <option value="157">Netherlands</option>
                <option value="158">New Caledonia</option>
                <option value="159">New Zealand</option>
                <option value="160">Nicaragua</option>
                <option value="161">Niger</option>
                <option value="162">Nigeria</option>
                <option value="163">Niue</option>
                <option value="164">Norfolk Island</option>
                <option value="165">Northern Mariana Islands</option>
                <option value="166">Norway</option>
                <option value="167">Oman</option>
                <option value="168">Pakistan</option>
                <option value="169">Palau</option>
                <option value="170">Palestine, State of</option>
                <option value="171">Panama</option>
                <option value="172">Papua New Guinea</option>
                <option value="173">Paraguay</option>
                <option value="174">Peru</option>
                <option value="175">Philippines</option>
                <option value="176">Pitcairn</option>
                <option value="177">Poland</option>
                <option value="178">Portugal</option>
                <option value="179">Puerto Rico</option>
                <option value="180">Qatar</option>
                <option value="181">RÃ©union</option>
                <option value="182">Romania</option>
                <option value="183">Russian Federation</option>
                <option value="184">Rwanda</option>
                <option value="185">Saint BarthÃ©lemy</option>
                <option value="187">Saint Kitts and Nevis</option>
                <option value="188">Saint Lucia</option>
                <option value="189">Saint Martin (French part)</option>
                <option value="190">Saint Pierre and Miquelon</option>
                <option value="191">Saint Vincent and the Grenadines</option>
                <option value="192">Samoa</option>
                <option value="193">San Marino</option>
                <option value="194">Sao Tome and Principe</option>
                <option value="195">Saudi Arabia</option>
                <option value="196">Senegal</option>
                <option value="197">Serbia</option>
                <option value="198">Seychelles</option>
                <option value="199">Sierra Leone</option>
                <option value="200">Singapore</option>
                <option value="201">Sint Maarten (Dutch part)</option>
                <option value="202">Slovakia</option>
                <option value="203">Slovenia</option>
                <option value="204">Solomon Islands</option>
                <option value="205">Somalia</option>
                <option value="206">South Africa</option>
                <option value="208">South Sudan</option>
                <option value="209">Spain</option>
                <option value="210">Sri Lanka</option>
                <option value="211">Sudan</option>
                <option value="212">Suriname</option>
                <option value="213">Svalbard and Jan Mayen</option>
                <option value="214">Swaziland</option>
                <option value="215">Sweden</option>
                <option value="216">Switzerland</option>
                <option value="217">Syrian Arab Republic</option>
                <option value="218">Taiwan, Province of China</option>
                <option value="219">Tajikistan</option>
                <option value="220">Tanzania, United Republic of</option>
                <option value="221">Thailand</option>
                <option value="222">Timor-Leste</option>
                <option value="223">Togo</option>
                <option value="224">Tokelau</option>
                <option value="225">Tonga</option>
                <option value="226">Trinidad and Tobago</option>
                <option value="227">Tunisia</option>
                <option value="228">Turkey</option>
                <option value="229">Turkmenistan</option>
                <option value="230">Turks and Caicos Islands</option>
                <option value="231">Tuvalu</option>
                <option value="232">Uganda</option>
                <option value="233">Ukraine</option>
                <option value="234">United Arab Emirates</option>
                <option value="235">United Kingdom</option>
                <option value="236">United States</option>
                <option value="237">United States Minor Outlying Islands</option>
                <option value="238">Uruguay</option>
                <option value="239">Uzbekistan</option>
                <option value="240">Vanuatu</option>
                <option value="241">Venezuela, Bolivarian Republic of</option>
                <option value="242">Viet Nam</option>
                <option value="243">Virgin Islands, British</option>
                <option value="244">Virgin Islands, U.S.</option>
                <option value="245">Wallis and Futuna</option>
                <option value="246">Western Sahara</option>
                <option value="247">Yemen</option>
                <option value="248">Zambia</option>
                <option value="249">Zimbabwe</option>
              </select>
            </td>
          </tr>

          <tr v-if="input.sec4PanProfileUpToDate == false && input.sec4PanContactWithC19Traveler == true">
            <td class="dialog-question-space">

            </td>
            <td class="dialog-sub-question border-dots-inner">
              {{ $t("DQ.explain") }}
            </td>

            <td class="dialog-input-field-explain border-dots"> 
              <textarea name="sec4PanContactWithC19Traveler" 
                        cols=2
                        style="width:100%;resize: none;height:100%;border-radius:5px;"
                        v-model="input.sec4PanContactWithC19TravelerExplain"
                        v-bind:placeholder="$t('DQ.explain')" 
                        :disabled="!input.sec4PanContactWithC19Traveler"
                        :class="input.sec4PanContactWithC19Traveler ? 'enabled' : 'disabled'"
                        maxlength="500"
                        />
            </td>
          </tr> 

          <tr v-if="input.sec4PanProfileUpToDate == false">
            
            <td colspan="2" class="dialog-question border-dots-inner">
              <!--Do you have any chronic medical conditions?-->
              <p class="wrap"> {{ $t("DQ.s4QC19ProfileQ5") }}</p>
            </td>
            
            <td class="dialog-input-field-right border-dots">
              <label for="chronicConditionsYes">{{ $t("DQ.yes") }}</label>&nbsp;
              <input type="radio" name="chronicConditionsYes" :value="true" v-model="input.sec4PanChronicConditions">
              &nbsp;
              <label for="chronicConditionsNo">{{ $t("DQ.no") }}</label>&nbsp;
              <input type="radio" name="chronicConditionsNo" :value="false" v-model="input.sec4PanChronicConditions"
              @click="onChronicConditions">
            </td>
          </tr>

          <tr v-if="input.sec4PanProfileUpToDate == false && input.sec4PanChronicConditions == true">
            <td class="dialog-question-space-alt">

            </td>
            <td class="dialog-sub-question-alt border-dots-inner">
              <!-- IF YES THE LIST -->
              {{ $t("DQ.ifYesList") }}
            </td>

            <td class="dialog-input-field-explain-alt border-dots"> 
              <textarea name="sec4PanChronicConditions" 
                        cols=2
                        style="width:100%;resize: none;height:100%;border-radius:5px;"
                        v-model="input.sec4PanChronicConditionsExplain"
                        v-bind:placeholder="$t('DQ.explain')" 
                        :disabled="!input.sec4PanChronicConditions"
                        :class="input.sec4PanChronicConditions ? 'enabled' : 'disabled'"
                        maxlength="500"
                        />
            </td>
          </tr> 

          <tr v-if="input.sec4PanProfileUpToDate == false">
            <td colspan="2" class="dialog-sub-question-alt border-dots-inner">
              <!--Do you have any compromised immunity issues?-->
              <p class="wrap"> {{ $t("DQ.s4QC19ProfileQ6") }}</p>
            </td>
            
            <td class="dialog-input-field-right-alt border-dots">
              <label for="compromisedImmunityYes">{{ $t("DQ.yes") }}</label>&nbsp;
              <input type="radio" name="compromisedImmunityYes" :value="true" v-model="input.sec4PanCompromisedImmunity">
              &nbsp;
              <label for="compromisedImmunityNo">{{ $t("DQ.no") }}</label>&nbsp;
              <input type="radio" name="compromisedImmunityNo" :value="false" v-model="input.sec4PanCompromisedImmunity"
              @click="onCompromisedImmunity">
            </td>
          </tr>

          <tr v-if="input.sec4PanProfileUpToDate == false && input.sec4PanCompromisedImmunity == true">
            <td class="dialog-question-space">

            </td>
            <td class="dialog-sub-question">
              <!-- IF YES THEN LIST -->
              {{ $t("DQ.ifYesList") }}
            </td>

            <td class="dialog-input-field-explain" > 
              <textarea name="sec4PanCompromisedImmunity" 
                        cols=2
                        style="width:100%;resize: none;height:100%;border-radius:5px;"
                        v-model="input.sec4PanCompromisedImmunityExplain"
                        v-bind:placeholder="$t('DQ.explain')" 
                        :disabled="!input.sec4PanCompromisedImmunity" 
                        :class="input.sec4PanCompromisedImmunity ? 'enabled' : 'disabled'"
                        maxlength="500"
                        />
            </td>
          </tr>

          <tr v-if="input.sec4PanProfileUpToDate == false">
            <!--I have answered the pandemic questions above and my profile is now up to date.-->
            
            <td colspan="3" class="dialog-input-field-right border-dots-inner">
              <div style="height:20px" />
              <label for="sec4PanProfileUpToDateYes">{{ $t("DQ.s4C19ProfileUpToDate") }}</label>&nbsp;
              <!--I have answered the pandemic questions above and my profile is now up to date.-->
              <input type="checkbox" name="sec4PanProfileUpToDate" v-model="input.sec4PanProfileUpToDate">
            </td>
          </tr>


          <tr>
            <td colspan="3" class="radius-bottom-left-field-top radius-bottom-left-field-bottom radius-bottom-right-field-top radius-bottom-right-field-bottom" style="background-color:#343F68">
              <div style="height:15px;"></div>
            </td>
          </tr>
          <!--<tr>
            <td class="dialog-question-space radius-bottom-left-field-top radius-bottom-left-field-bottom">
            </td>
            <td class="dialog-sub-question">
            </td>
            <td class="section-footer radius-bottom-right-field-top radius-bottom-right-field-bottom" > 
            </td>
          </tr>-->
          <!-- END SECTION 4 -->
          
          <!-- 
            *******************************************
            *        SECTION 5 - VACCINATIONS         *
            *******************************************
          -->
          <div style="height:10px;"></div>
          <tr>
            <td class="dialog-signon-td-section-title radius-top-left-field-top radius-top-left-field-bottom radius-top-right-field-top radius-top-right-field-bottom" colspan="3">
              <!--SECTION 5. - VACCINATIONS-->
              <p> {{ $t("DQ.s5Title") }}</p>
            </td>
          </tr>
          <tr>
            <td class="dialog-question-space" colspan="3">
              <div style="height:20px" />
            </td>
          </tr>
          <tr>
            <td colspan="2" class="dialog-question border-dots-inner">
             <p class="wrap"> {{ $t("DQ.s5VaccinationQ1") }}</p>
             <!--Is your vaccination profile information with us up to date?-->
            </td>
            
            <td class="dialog-input-field-right border-dots">
              <label for="vaccinationYes">{{ $t("DQ.yes") }}</label>&nbsp;
              <input type="radio" name="vaccinationYes" :value="true" v-model="input.vaccination">
              &nbsp;
              <label for="vaccinationNo">{{ $t("DQ.noNotSure") }}</label>&nbsp;
              <input type="radio" name="vaccinationNo" :value="false" v-model="input.vaccination"
              @click="onVaccination">
            </td>
          </tr>

          <tr v-if="input.vaccination == false">
            <td class="dialog-question-space-alt">

            </td>
            <td class="dialog-sub-question-alt border-dots-inner">             
              {{ $t("DQ.s5VaccinationQ2") }}
              <!--	Please tell us which vaccine you are taking?-->
            </td>
            <td id="vaccineId" class="dialog-input-field-right-alt border-dots"> 
              <select name="vaccineId" 
                      v-model="input.vaccineId"
                      style="border-radius:5px;">
                      <!--:disabled="input.vaccination"
                          :class="input.vaccination ? 'enabled' : 'disabled'"-->
                <option value="0">{{ $t("DQ.selectOne") }}</option>
                <option value="1">Pfizer</option>
                <option value="2">Moderna</option>
                <option value="3">Johnson &amp; Johnson</option>               
              </select>
            </td>
          </tr>
          <tr v-if="input.vaccination == false && input.vaccineId == 3">
            <td class="dialog-question-space">
            </td>
            <td class="dialog-sub-question">
                {{ $t("DQ.s5VaccineDose1") }}
                <!--On what date did you receive your first dose?-->
            </td>
            <td class="dialog-input-field-explain"> 
              <input type="date" style="border-radius:5px;" v-model="vaccineDose1">
            </td>
          </tr>
          <!-- booster -->
          <tr v-if="input.vaccination == false && input.vaccineId == 3">
            <td class="dialog-question-space-alt">
            </td>
            <td class="dialog-sub-question-alt">
                {{ $t("DQ.s5VaccineDose3") }}
                <!--Have you had a booster shot? If so, then please tell us the date of your booster dose?-->
            </td>
            <td class="dialog-input-field-explain-alt"> 
              <input type="date" style="border-radius:5px;" v-model="vaccineDose3">
            </td>
          </tr>
          <tr v-if="input.vaccination == false && (input.vaccineId == 1 || input.vaccineId == 2)">
            <td class="dialog-question-space">
            </td>
            <td class="dialog-sub-question">
                {{ $t("DQ.s5VaccineDose1") }}
                <!--On what date did you receive your first dose?-->
            </td>
            <td class="dialog-input-field-explain"> 
              <input type="date" style="border-radius:5px;" v-model="vaccineDose1">
            </td>
          </tr>
          <tr v-if="input.vaccination == false && (input.vaccineId == 1 || input.vaccineId == 2)">
            <td class="dialog-question-space-alt">
            </td>
            <td class="dialog-sub-question-alt">
                {{ $t("DQ.s5VaccineDose2") }}
                <!--On what date did you receive your second dose?-->
            </td>
            <td class="dialog-input-field-explain-alt"> 
              <input type="date" style="border-radius:5px;" v-model="vaccineDose2">
            </td>
          </tr> 
          <!-- booster -->
          <tr v-if="input.vaccination == false && (input.vaccineId == 1 || input.vaccineId == 2)">
            <td class="dialog-question-space">
            </td>
            <td class="dialog-sub-question">
                {{ $t("DQ.s5VaccineDose3") }}
                <!--Have you had a booster shot? If so, then please tell us the date of your booster dose?-->
            </td>
            <td class="dialog-input-field-explain"> 
              <input type="date" style="border-radius:5px;" v-model="vaccineDose3">
            </td>
          </tr>

          <tr v-if="input.vaccination == false">
            <!--I have answered the vaccination questions above and my profile is now up to date.-->
            
            <td colspan="3" class="dialog-input-field-right border-dots-inner">
              <div style="height:20px" />
              <label for="vaccinationUpToDate">{{ $t("DQ.s5VaccinesProfileUpToDate")  }}</label>&nbsp;
              <!--I have answered the vaccination questions above and my profile is now up to date.-->
              <input type="checkbox" name="vaccinationUpToDate" v-model="input.vaccination">
            </td>
          </tr>
          <tr>
            <td colspan="3" class="radius-bottom-left-field-top radius-bottom-left-field-bottom radius-bottom-right-field-top radius-bottom-right-field-bottom" style="background-color:#343F68">
              <div style="height:15px;"></div>
            </td>
          </tr>
          <!--<tr>
            <td class="dialog-question-space radius-bottom-left-field-bottom radius-bottom-left-field-top">
            </td>
            <td class="dialog-sub-question">
            </td>
            <td class="section-footer radius-bottom-right-field-top radius-bottom-right-field-bottom" > 
            </td>
          </tr>-->

          <!-- 
            *******************************************
            *           SECTION 6 - TERMS             *
            *******************************************
          -->

          <!-- TERMS-->
          <div style="height:10px;"></div>

          <tr>
            <td class="dialog-signon-td-section-title radius-top-left-field-top radius-top-left-field-bottom radius-top-right-field-top radius-top-right-field-bottom" colspan="3">
              <!-- TERMS TITLE -->
              <p> {{ $t("DQ.termsTitle") }}</p>
            </td>
          </tr>
          <tr>
            <td class="dialog-question-space" colspan="3">
              <div style="height:20px" />
            </td>
          </tr>
          <tr>
            <td class="dialog-question-space ">
            </td>
            <td class="dialog-sub-question" >
              <!-- TERMS STATEMENT -->
              {{ $t("DQ.termsStatement") }}
            </td>
            <td class="dialog-input-field-right" >
              <!-- AGREE -->
              <label for="agreementYes">{{ $t("DQ.termsAgree") }}</label>&nbsp;
              <input type="checkbox" name="agreementYes" value:="true" v-model="input.agreement">
              <div style="width:250px;height:0px"></div>
            </td>
          </tr>

          <tr>
            <td colspan="3" class="radius-bottom-left-field-top radius-bottom-left-field-bottom radius-bottom-right-field-top radius-bottom-right-field-bottom" style="background-color:#343F68">
              <div style="height:15px;"></div>
            </td>
          </tr>

          <!--<tr>
            <td class="dialog-question-space radius-bottom-left-field-bottom radius-bottom-left-field-top">
            </td>
            <td class="dialog-sub-question">
            </td>
            <td class="section-footer radius-bottom-right-field-top radius-bottom-right-field-bottom" > 
            </td>
          </tr>-->
          
          <div style="height:10px;"></div>

          <tr>
            <td class="dialog-input-submit" colspan="3" align="center" style="border-top-left-radius:15px;border-top-right-radius:15px;  border-bottom-left-radius:15px;border-bottom-right-radius:15px;">
                <input type="button" v-on:click="submit()" :disabled="input.isLoading" v-bind:value="$t('DQ.submit')" >
            </td>
          </tr>
      
        </table>
      </td>
    </tr>
    
    <tr>
      <td id="main-table-row3" colspan="1" > 
      </td>
    </tr>
  </table>

  </div>
</template>

<script>
    //import { API } from '../../../api/member-api'
    const { API } = require( '../../../api/member-api' + '?v=' + process.env.VUE_APP_VERSION )

    //import { SUPPORT } from '../../../api/member-api'
    const { SUPPORT } = require( '../../../api/member-api' + '?v=' + process.env.VUE_APP_VERSION )

    import messageBox from '.././common/message-box'
    import confirmBox from './c19-confirm-box'
    import moment from 'moment'

    export default {
      name: 'daily-questionniare',
      mounted(){
        
        // SHOW TOP OF VIEW
        window.scrollTo(0, 0);

        this.load();
      },
      computed:
      { 
        vaccineDose1:
        {
          get() {
            if(new Date(this.input.vaccineDose1).getTime() == new Date("1900-01-01T00:00:00").getTime())
            { 
              return "";
            }
            return moment(this.input.vaccineDose1).format('YYYY-MM-DD');
          },
          set(val)
          {
            this.input.vaccineDose1 = val;
          }
        }, 
        vaccineDose2:
        {
          get() {
            if(new Date(this.input.vaccineDose2).getTime() == new Date("1900-01-01T00:00:00").getTime())
            { 
              return "";
            }
            return moment(this.input.vaccineDose2).format('YYYY-MM-DD');
          },
          set(val)
          {
            this.input.vaccineDose2 = val;
          }
        }, 
        vaccineDose3:
        {
          get() {
            if(new Date(this.input.vaccineDose3).getTime() == new Date("1900-01-01T00:00:00").getTime())
            { 
              return "";
            }
            return moment(this.input.vaccineDose3).format('YYYY-MM-DD');
          },
          set(val)
          {
            this.input.vaccineDose3 = val;
          }
        }
      },
      data() {        
      return {
        input: {
            isLoading: false,
            dailyQuestionnaireTypeId:2,
            //dailyQuestionnaireStatusId,
            sec1MoodRating:0,
            sec2IllnessFeelingSick:false,
            sec2IllnessInterfereWithDuties:false,
            sec2IllnessExplanation:"",
            sec2StressFeelingStress:false,
            sec2StressLongWorkloadHours:false,
            sec2StressWorkplaceChallenges:false,
            sec2StressPersonalCauses:false,
            sec2StressExplanation:"",
            sec2AlcoholWithinPast24Hours:false,
            sec2AlcoholHoursSinceLastDrink:0,
            sec2FatigueMuscular:false,
            sec2FatigueExperiencing:false,
            sec2FatigueMental:false,
            sec2FatigueEmotional:false,
            sec2FatigueLackOfSleep:false,
            sec2FatigueChronicLackOfSleep:false,
            sec2FatigueExplanation:"",
            sec2EmotionRecentTrauma: false,
            sec2EmotionExplanation:"",
            sec3MentalHealthFeelingToday:false,
            sec3MentalHealthPast2Weeks:false,
            sec3MentalHealthNervouseAnxious:0,
            sec3MentalHealthWorrying:0,
            sec3MentalHealthNoInterest:0,
            sec3MentalHealthDepressed:0,
            sec3MentalHealthSuicidalHomicidal:0,
            sec3FatigueWakeRestful:true,
            sec3FatigueHoursOfSleep:0,
            sec3FatigueSleepSameTime:true,
            sec3FatigueUseCPAP:false,
            sec3FatigueUseCPAPDuringLastSleep:false,
            sec3FatigueCPAPRequired:false,
            sec3InstructionsFollowingDoctorOrders:true,
            sec3MedsTakingAny:false,
            sec3MedsTakingAsPrescribed:true,
            sec3MedsStateOfMind:false,
            sec3MedsInterfereWithJob:false,
            sec3MedsTakingSupplements:false,
            sec3MedsExplanation:"",
            sec3AccommodationNeeded:false,
            sec3AccomodationJobAppAdjustment:false,
            sec3AccommodationScheduleModification:false,
            sec3AccommodationEqualBenefitsChange:false,
            sec3AccommodationDoctorsAppointment:false,
            sec3OtherBotheringYou:false,
            sec3OtherExplanation:"",
            sec3TempValue:"",
            sec3TempPastNDays:false,
            sec3TempUsedDigitalThermometer:false,
            sec3SymptomWetCoughProductive:false,
            sec3SymptomWetCoughNonProductive:false,
            sec3SymptomDryCough:false,
            sec3SymptomSoreThroat:false,
            sec3SymptomCongestionRunningNose:false,
            sec3SymptomShortnessOfBreath:false,
            sec3SymptomChills:false,
            sec3SymptomHeadache:false,
            sec3SymptomLossOfSmell:false,
            sec3SymptomLossOfTaste:false,
            sec3SymptomLossOfAppetite:false,
            sec3SymptomPinkEye:false,
            sec3SymptomBodyAchesPain:false,
            sec3SymptomSuddenConfusion:false,
            sec3SymptomDigestiveSystem:false,
            sec3SymptomFatigue:false,
            sec3SymptomChestPain:false,
            sec3SymptomStartDate:"",
            sec4PanProfileUpToDate:false,
            sec4PanCurrentlyHaveC19:false,
            sec4PanPrevTestedPositiveForC19:false,
            sec4PanPrevTestedPositiveForC19A:false,
            sec4PanPrevTestedPositiveForC19B:false,
            sec4PanPrevTestedPositiveForC19C:false,
            sec4PanContactWithC19DiagnosedPerson:false,
            sec4PanContactWithC19DiagnosedPersonExplain:"",
            sec4PanContactWithC19Traveler:false,
            sec4PanContactWithC19TravelerCountryId:0,
            sec4PanContactWithC19TravelerExplain:"",
            sec4PanChronicConditions:false,
            sec4PanChronicConditionsExplain:"",
            sec4PanCompromisedImmunity:false,
            sec4PanCompromisedImmunityExplain:"",
            vaccination:false,
            vaccineId:0,
            vaccineDose1:"1/1/1900",
            vaccineDose2:"1/1/1900",
            vaccineDose3:"1/1/1900"
        },
        pageYOffset:0,
      }
  },
  methods:
  {
    load()
    {
      try
      {
        if(window.sessionKey != '')
        {
          // CHANGE THE MENU FROM LOGON
          
          SUPPORT.showServiceMenus();
          document.getElementById('menuLogoff').classList.remove('is-hidden');
          document.getElementById('menuMember').innerHTML = '<span v-on:click="toggleMenus" style="white-space:pre">Hi ' + window.firstName + '</span>'
          document.getElementById('menuQuestionnaire').classList.add('is-hidden');
        }                   

        API.readDailyQuestionnaire(window.sessionKey, this.$i18n.locale)
        .then(response => {
          if(response.data.hasError == true)
          {
            this.input.isLoading = false;
            this.$generalMessage(messageBox, response.data.errorMessage);
            SUPPORT.securityCheck(response.data.errorId);
          }
          else
          { 
            if(response.data.inviteRequired)
            {              
              // REDIRECT TO MANAGE INVITES
               let menuCOVID19Questionnaire = document.getElementById('menuCOVID19Questionnaire');
              menuCOVID19Questionnaire.classList.remove('is-hidden');
              this.$router.push( { path: "/members/invite"} );
              return;
            }

            this.input.sec4PanProfileUpToDate = response.data.sec4PanProfileUpToDate;
            this.input.sec4PanCurrentlyHaveC19 = response.data.sec4PanCurrentlyHaveC19;
            this.input.sec4PanPrevTestedPositiveForC19 = response.data.sec4PanPrevTestedPositiveForC19;
            this.input.sec4PanPrevTestedPositiveForC19A = response.data.sec4PanPrevTestedPositiveForC19A;
            this.input.sec4PanPrevTestedPositiveForC19B = response.data.sec4PanPrevTestedPositiveForC19B;
            this.input.sec4PanPrevTestedPositiveForC19C = response.data.sec4PanPrevTestedPositiveForC19C;
            this.input.sec4PanContactWithC19DiagnosedPerson = response.data.sec4PanContactWithC19DiagnosedPerson;
            this.input.sec4PanContactWithC19DiagnosedPersonExplain = response.data.sec4PanContactWithC19DiagnosedPersonExplain;
            this.input.sec4PanContactWithC19Traveler = response.data.sec4PanContactWithC19Traveler;
            this.input.sec4PanContactWithC19TravelerCountryId = response.data.sec4PanContactWithC19TravelerCountryId;
            this.input.sec4PanContactWithC19TravelerExplain = response.data.sec4PanContactWithC19TravelerExplain;
            this.input.sec4PanChronicConditions = response.data.sec4PanChronicConditions;
            this.input.sec4PanChronicConditionsExplain = response.data.sec4PanChronicConditionsExplain;
            this.input.sec4PanCompromisedImmunity = response.data.sec4PanCompromisedImmunity;
            this.input.sec4PanCompromisedImmunityExplain = response.data.sec4PanCompromisedImmunityExplain;
            this.input.vaccination = response.data.vaccination;
            this.input.vaccineId = response.data.vaccineId;
            this.input.vaccineDose1 = response.data.vaccineDose1; //moment(response.data.vaccineDose1).format('MM-DD-YYYY');
            this.input.vaccineDose2 = response.data.vaccineDose2; //moment(response.data.vaccineDose2).format('MM-DD-YYYY');
            this.input.vaccineDose3 = response.data.vaccineDose3; 

          }
        }).catch( e =>
        {
          this.$generalMessage( messageBox, e );            
        })
      }
      catch(e)
      {
        this.$generalMessage( messageBox, e );
      }
    },
    submit()
    {
      this.input.isLoading = true;
      this.pageYOffset = window.pageYOffset;

      // VALIDATE INPUT RULES      
      if(!this.validate())
      {
        this.input.isLoading = false;
        window.scrollTo(0, window.pageYOffset);
        return;
      }

      var message = this.buildPositiveList();
    
      /* NEW CONFIRMATION METHOD */
      if(SUPPORT.isSupported())
      {
        var clientWidth = document.documentElement.clientWidth;
        var theWidth = (clientWidth > 1023) ? 600 : 300;
        //var theHeight = (clientWidth < 600) ? 250 : 200;
        var theHeight = (clientWidth < 600) ? 385 : 350;

        // DISPLAY THE STD MESSAGE INFORMATION BOX
        this.$modal.show(confirmBox, {
          text: message,
          func: this.confirmCallBack,
        }, 
        {
          draggable: true,
          width: theWidth, 
          height: theHeight,
          clickToClose: false,
          styles: {"border-radius":"15px"}
        });
      }
      else{
        
        var title = this.$t("c19confirm.statement") //"eHealth Engagement, LLC.\n\nYou answered Yes to the following questions. Please review and confirm your entries.\n\n";
        var msg = ''
        var i = 0;
        for(i = 0; i < message.length ; i++) 
        {
          msg = msg + message[i] + '\n';
        }
        
        var r = confirm(title + msg);
        if(r == true)
        {
          this.confirmCallBack(1);
        }
        else
        {
          this.input.isLoading = false;
          this.confirmCallBack(0);
        }
      }
     
    },
    confirmCallBack(result)
    {
      
      if(result == 1) // YES RETURN RESULT
      {
        this.submit2();
      }
      else
      {
        
        if(this.input.sec3SymptomStartDate == "1900-01-01")
        {
          
          this.input.sec3SymptomStartDate = "1900-01-01";
        }
        
        this.input.isLoading = false;
        window.scrollTo(0, this.pageYOffset);
      }
    },
    getMentalHealthState(id)
    {
      switch(id)
      {
        case 1:
          {
            return this.$t("DQ.selectOne") ;
          }
          case 2:
          {
            return this.$t("DQ.notAtAll") ;
          }
          case 3:
          {
            return this.$t("DQ.serveralDays") ;
          }
          case 4:
          {
            return this.$t("DQ.moreThanHalfTheDays");             
          }
          case 5:
          {
            return this.$t("DQ.nearlyEveryday");
          }
      }
    },
    buildPositiveList()
    {
      var list = Array();

      // SECTION 1 - MOOD
      if(this.input.sec1MoodRating > 0)
      {
        switch(this.input.sec1MoodRating)
        {
          case"1":
            {
              list.push(this.$t("DQ.list_Mood1") + " = " + this.$t("DQ.moodRatingBad"));
              //"MOOD - How would you rate your mood today?
              break;
            }
          case "2":
            {
              list.push(this.$t("DQ.list_Mood1") + " = " + this.$t("DQ.moodRatingNotGood"));
              //"MOOD - How would you rate your mood today?
              break;
            }
          case "3":
            {
              list.push(this.$t("DQ.list_Mood1") + " = " + this.$t("DQ.moodRatingAverage"));
              //"MOOD - How would you rate your mood today?
              break;
            }
          case "4":
            {
              list.push(this.$t("DQ.list_Mood1") + " = " + this.$t("DQ.moodRatingGood"));
              //"MOOD - How would you rate your mood today?
              break;
            }
          case "5":
            {
              list.push(this.$t("DQ.list_Mood1") + " = " + this.$t("DQ.moodRatingGreat"));
              //"MOOD - How would you rate your mood today?
              break;
            }
        }
      }
      // END SECTION 1

      // SECTION 2 - PRE-WORK SHIFT MEDICAL CHECKLIST
      // ILLNESS
      if(this.input.sec2IllnessFeelingSick == true )
      {
        list.push(this.$t("DQ.list_Illness1") + " = "  + this.$t("DQ.yes"));
        //ILLNESS - Are you feeling sick?
      }

      if(this.input.sec2IllnessInterfereWithDuties == true )
      {
        list.push(this.$t("DQ.list_Illness2") + " = "  + this.$t("DQ.yes"));
        //ILLNESS - Do you believe that this could interfere with your duties?
      }
      if(this.input.sec2IllnessExplanation.length > 0)
      {
        list.push(this.$t("DQ.list_Illness3") + " = "  + this.$t("DQ.yes"));
        //ILLNESS - Explanation provided.
      }

      // MEDICATIONS
      if(this.input.sec3MedsTakingAny == true)
      {
        list.push(this.$t("DQ.list_Medication1") + " = "  + this.$t("DQ.yes"));
        //MEDICATION - Are you taking any medications or supplements?
      }
      if(this.input.sec3MedsTakingAsPrescribed == false)
      {
        list.push(this.$t("DQ.list_Medication2") + " = "  + this.$t("DQ.no"));
        //MEDICATION - Have you been taking your medications as prescribed by your physician?
      }
      if(this.input.sec3MedsStateOfMind == true)
      {
        list.push(this.$t("DQ.list_Medication3") + " = "  + this.$t("DQ.yes"));
        //MEDICATION - Have you taken any medication that could affect your state of mind?
      }
      if(this.input.sec3MedsInterfereWithJob == true)
      {
        list.push(this.$t("DQ.list_Medication4") + " = "  + this.$t("DQ.yes"));
        //MEDICATION - Have you taken any medications that could interfere with overall safety while on the job?",
      }
      if(this.input.sec3MedsTakingSupplements == true)
      {
        list.push(this.$t("DQ.list_Medication5") + " = "  + this.$t("DQ.yes"));
        //MEDICATION - Are you taking any supplements?
      }
      if(this.input.sec3MedsExplanation.length > 0)
      {
        list.push(this.$t("DQ.list_Medication6") + " = "  + this.$t("DQ.yes"));
        //MEDICATION - Medications list provided.
      }

      // STRESS
      if(this.input.sec2StressFeelingStress == true)
      {
        list.push(this.$t("DQ.list_Stress1") + " = "  + this.$t("DQ.yes"));
        //STRESS - Are you feeling any stress?
      }
      if(this.input.sec2StressLongWorkloadHours == true)
      {
        list.push(this.$t("DQ.list_Stress2") + " = "  + this.$t("DQ.yes"));
        //STRESS - Long workload or work hours?
      }
      if(this.input.sec2StressWorkplaceChallenges == true)
      {
        list.push(this.$t("DQ.list_Stress3") + " = "  + this.$t("DQ.yes"));
        //STRESS - Workplace challenges?
      }
      if(this.input.sec2StressPersonalCauses == true)
      {
        list.push(this.$t("DQ.list_Stress4") + " = "  + this.$t("DQ.yes"));
        //STRESS - Personal causes?
      }
      if(this.input.sec2StressExplanation.length > 0)
      {
        list.push(this.$t("DQ.list_Stress5") + " = "  + this.$t("DQ.yes"));
        //STRESS - Explanation provided.
      }

      // ALCOHOL
      if(this.input.sec2AlcoholWithinPast24Hours == true)
      {
        list.push(this.$t("DQ.list_Alcohol1") + " = "  + this.$t("DQ.yes"));
        //ALCOHOL - Have you consumed any alcohol within the past 24 hours?
      }
      if(this.input.sec2AlcoholHoursSinceLastDrink > 0)
      {
        list.push(this.$t("DQ.list_Alcohol2") + " = "  + this.input.sec2AlcoholHoursSinceLastDrink);
        //ALCOHOL - How many hours has it been since you had your last drink?
      }

      // FATIGUE
      if(this.input.sec2FatigueMuscular == true)
      {
         list.push(this.$t("DQ.list_Fatigue1") + " = "  + this.$t("DQ.yes"));
         //FATIGUE - Strenuous muscular effort?
      }
      if(this.input.sec2FatigueMental == true)
      {
         list.push(this.$t("DQ.list_Fatigue2") + " = "  + this.$t("DQ.yes"));
         //FATIGUE - Heavy mental work?
      }
      if(this.input.sec2FatigueEmotional == true)
      {
         list.push(this.$t("DQ.list_Fatigue3") + " = "  + this.$t("DQ.yes"));
         //FATIGUE - Strong emotional pressure?
      }
      if(this.input.sec2FatigueExplanation.length > 0)
      {
        list.push(this.$t("DQ.list_Fatigue4") + " = "  + this.$t("DQ.yes"));
        //FATIGUE - Explanation provided.
      }

      // SLEEP
      if(this.input.sec2FatigueLackOfSleep == true)
      {
        list.push(this.$t("DQ.list_Sleep1") + " = "  + this.$t("DQ.yes"));
        //SLEEP - Have you experienced a lack of sleep in the past 8 hours?
      }
      if(this.input.sec3FatigueWakeRestful == false)
      {
        list.push(this.$t("DQ.list_Sleep2") + " = "  + this.$t("DQ.no"));
        //"SLEEP - Did you wake restful?
      }
      if(this.input.sec2FatigueChronicLackOfSleep == true)
      {
        list.push(this.$t("DQ.list_Sleep3") + " = "  + this.$t("DQ.yes"));
        //SLEEP - Have you been experiencing an ongoing chronic Lack of sleep?
      }
      if(this.input.sec3FatigueHoursOfSleep > 0)
      {
        list.push(this.$t("DQ.list_Sleep4") + " = "  + this.input.sec3FatigueHoursOfSleep);
        //SLEEP - How many hours did you sleep prior to this upcoming work shift?
      }
      if(this.input.sec3FatigueSleepSameTime == false)
      {
        list.push(this.$t("DQ.list_Sleep5") + " = "  + this.$t("DQ.no"));
        //SLEEP - Do you go to sleep within an hour of the same time each night?
      }
      if(this.input.sec3FatigueUseCPAP == true)
      {
        list.push(this.$t("DQ.list_Sleep6") + " = "  + this.$t("DQ.yes"));
        //SLEEP/CPAP - Do you use a CPAP (Continuous Positive Airway Pressure device)?
      }
      if(this.input.sec3FatigueUseCPAPDuringLastSleep == true)
      {
        list.push(this.$t("DQ.list_Sleep7") + " = "  + this.$t("DQ.yes"));
        //SLEEP/CPAP - Did you use your CPAP the last time you slept?
      }
      if(this.input.sec3FatigueCPAPRequired == true)
      {
        list.push(this.$t("DQ.list_Sleep8") + " = "  + this.$t("DQ.yes"));
        //SLEEP/CPAP - Are you required by a physician to use your CPAP?
      }

      // EMOTION
      if(this.input.sec2EmotionRecentTrauma == true)
      {
         list.push(this.$t("DQ.list_Emotion1") + " = "  + this.$t("DQ.yes"));
         //EMOTION - Have you experienced any traumatic personal or work events recently?
      }
      if(this.input.sec2EmotionExplanation.length > 0)
      {
        list.push(this.$t("DQ.list_Emotion2") + " = "  + this.$t("DQ.yes"));
        //EMOTION - Explanation provided.
      }
      // END SECTION 2

      // SECTION 3
      // Q1 MENTAL HEALTH
      if(this.input.sec3MentalHealthFeelingToday == true)
      {
         list.push(this.$t("DQ.list_Wellness1") + " = "  + this.$t("DQ.s3FeelingTodayNotGreat"));
         //MEDICAL WELLNESS - How are you feeling today?
      }
      if(this.input.sec3MentalHealthPast2Weeks == true)
      {
        list.push(this.$t("DQ.list_Wellness2") + " = "  + this.$t("DQ.yes"));
        //MENTAL HEALTH - Have you experienced any Anxiety and or Depression over the past 2 weeks?
      }
      if(this.input.sec3MentalHealthNervouseAnxious > 0)
      {
        list.push(this.$t("DQ.list_Wellness3") + " = " + this.getMentalHealthState(this.input.sec3MentalHealthNervouseAnxious));
        //MENTAL HEALTH - Feeling nervous, anxious or on edge.
      }
      if(this.input.sec3MentalHealthWorrying > 0)
      {
        list.push(this.$t("DQ.list_Wellness4") + " = " + this.getMentalHealthState(this.input.sec3MentalHealthWorrying));
        //MENTAL HEALTH - Not being able to stop or control worrying.
      }
      if(this.input.sec3MentalHealthNoInterest > 0)
      {
        list.push(this.$t("DQ.list_Wellness5") + " = " + this.getMentalHealthState(this.input.sec3MentalHealthNoInterest));
        //MENTAL HEALTH - Little interest or pleasure in doing things.
      }
      if(this.input.sec3MentalHealthDepressed > 0)
      {
        list.push(this.$t("DQ.list_Wellness6") + " = " + this.getMentalHealthState(this.input.sec3MentalHealthDepressed));
        //MENTAL HEALTH - Feeling down, depressed, or hopeless.
      }
      if(this.input.sec3MentalHealthSuicidalHomicidal > 0)
      {
        list.push(this.$t("DQ.list_Wellness7") + " = " + this.getMentalHealthState(this.input.sec3MentalHealthSuicidalHomicidal));
        //MENTAL HEALTH - Feeling Suicidal or Homicidal.
      }      
      //Q2 DOCTORS RECOMMENDATIONS
      if(this.input.sec3InstructionsFollowingDoctorOrders == false)
      {
        list.push(this.$t("DQ.list_Wellness8") + " = "  + this.$t("DQ.yes"));
        //MEDICAL WELLNESS - Have you been following any/all of your doctor's health recommendations?
      }
      //Q3 ACCOMMODATIONS
      if(this.input.sec3AccommodationNeeded == true)
      {
        list.push(this.$t("DQ.list_Wellness9") + " = "  + this.$t("DQ.yes"));
        //ACCOMMODATIONS - Do you need any Accommodations today?
      }
      if(this.input.sec3AccomodationJobAppAdjustment == true)
      {
        list.push(this.$t("DQ.list_Wellness110") + " = "  + this.$t("DQ.yes"));
        //ACCOMMODATIONS - Request an adjustments to the job application process so a qualified applicant with a disability can be considered for a position.
      }
      if(this.input.sec3AccommodationScheduleModification == true)
      {
        list.push(this.$t("DQ.list_Wellness11") + " = "  + this.$t("DQ.yes"));
        //ACCOMMODATIONS -  Request a modification to the physical work environment, or to the way a job is usually performed, so an individual with a disability can perform the essential functions of that position.
      }
      if(this.input.sec3AccommodationEqualBenefitsChange == true)
      {
        list.push(this.$t("DQ.list_Wellness12") + " = "  + this.$t("DQ.yes"));
        //ACCOMMODATIONS - Request changes that enable an employee with a disability to enjoy equal benefits and privileges of employment like those that are enjoyed by other employees without disabilities. This may include access to cafeterias, lounges, auditoriums, and company-provided transportation.
      }
      if(this.input.sec3AccommodationDoctorsAppointment == true)
      {
        list.push(this.$t("DQ.list_Wellness13") + " = "  + this.$t("DQ.yes"));
        //ACCOMMODATIONS - Request a doctors appointment.
      }
      // Q4 OTHER
      if(this.input.sec3OtherBotheringYou == true)
      {
        list.push(this.$t("DQ.list_Wellness14") + " = "  + this.$t("DQ.yes"));
        //MEDICAL WELLNESS - Is something else bothering you today?
      }
      if(this.input.sec3OtherExplanation.length > 0)
      {
        list.push(this.$t("DQ.list_Wellness15") + " = "  + this.$t("DQ.yes"));
        //MEDICAL WELLNESS - Explantion provided
      }
      //Q5 TEMPERATURE
      if(this.input.sec3TempValue != "")
      {
        list.push(this.$t("DQ.list_Wellness16") + " = "  + this.input.sec3TempValue);
        //TEMPERATURE - Please enter your temperature reading for today:
      }
      if(this.input.sec3TempPastNDays == true)
      {
        list.push(this.$t("DQ.list_Wellness17") + " = "  + this.$t("DQ.yes"));
        //TEMPERATURE - Have you had a temperature greater than 100.4 within the past 3 days?
      }
      if(this.input.sec3TempUsedDigitalThermometer == true)
      {
        list.push(this.$t("DQ.list_Wellness18") + " = "  + this.$t("DQ.yes"));
        //TEMPERATURE - Did you use a digital thermometer?
      }
      //Q6 SYMPTOMS
      
      if(this.input.sec3SymptomWetCoughProductive == true)
      {
        list.push(this.$t("DQ.list_Wellness19") + " = "  + this.$t("DQ.yes"));
        //SYMPTOM - Wet cough - Productive (A cough that produces mucus or phlegm.)
      }
      if(this.input.sec3SymptomWetCoughNonProductive == true)
      {
        list.push(this.$t("DQ.list_Wellness20") + " = "  + this.$t("DQ.yes"));
        //SYMPTOM - Wet cough - Non-productive (Does not bring up any mucus or phlegm.)
      }
      if(this.input.sec3SymptomDryCough == true)
      {
        list.push(this.$t("DQ.list_Wellness21") + " = "  + this.$t("DQ.yes"));
        //SYMPTOM - Dry cough - (Does not bring up any mucus or phlegm.)
      }
      if(this.input.sec3SymptomSoreThroat == true)
      {
        list.push(this.$t("DQ.list_Wellness22") + " = "  + this.$t("DQ.yes"));
        //SYMPTOM - Sore throat
      }
      if(this.input.sec3SymptomCongestionRunningNose == true)
      {
        list.push(this.$t("DQ.list_Wellness23") + " = "  + this.$t("DQ.yes"));
        //SYMPTOM - Congestion and/or running nose (Not related to seasonal allergies.)
      }
      if(this.input.sec3SymptomShortnessOfBreath == true)
      {
        list.push(this.$t("DQ.list_Wellness24") + " = "  + this.$t("DQ.yes"));
        //SYMPTOM - Shortness of breath
      }
      if(this.input.sec3SymptomChills == true)
      {
        list.push(this.$t("DQ.list_Wellness25") + " = "  + this.$t("DQ.yes"));
        //SYMPTOM - Chills
      }
      if(this.input.sec3SymptomHeadache == true)
      {
        list.push(this.$t("DQ.list_Wellness26") + " = "  + this.$t("DQ.yes"));
        //SYMPTOM - Headache
      }
      if(this.input.sec3SymptomLossOfSmell == true)
      {
        list.push(this.$t("DQ.list_Wellness27") + " = "  + this.$t("DQ.yes"));
        //SYMPTOM - Loss of smell
      }
      if(this.input.sec3SymptomLossOfTaste == true)
      {
        list.push(this.$t("DQ.list_Wellness28") + " = "  + this.$t("DQ.yes"));
        //SYMPTOM - Loss of taste
      }
      if(this.input.sec3SymptomLossOfAppetite == true)
      {
        list.push(this.$t("DQ.list_Wellness29") + " = "  + this.$t("DQ.yes"));
        //SYMPTOM - Loss of appetite
      }
      if(this.input.sec3SymptomPinkEye == true)
      {
        list.push(this.$t("DQ.list_Wellness30") + " = "  + this.$t("DQ.yes"));
        //SYMPTOM - Red eyes (Not related to seasonal allergies.)
      }
      if(this.input.sec3SymptomBodyAchesPain == true)
      {
        list.push(this.$t("DQ.list_Wellness31") + " = "  + this.$t("DQ.yes"));
        //SYMPTOM - Body aches muscle and/or joint pain
      }
      if(this.input.sec3SymptomSuddenConfusion == true)
      {
        list.push(this.$t("DQ.list_Wellness32") + " = "  + this.$t("DQ.yes"));
        //SYMPTOM - Sudden confusion
      }
      if(this.input.sec3SymptomDigestiveSystem == true)
      {
        list.push(this.$t("DQ.list_Wellness33") + " = "  + this.$t("DQ.yes"));
        //SYMPTOM - Digestive symptoms including diarrhea
      }
      if(this.input.sec3SymptomFatigue == true)
      {
        list.push(this.$t("DQ.list_Wellness34") + " = "  + this.$t("DQ.yes"));
        //SYMPTOM - Fatigue (Unusual or excessive whole-body tiredness not relieved by sleep.)
      }
      if(this.input.sec3SymptomChestPain == true)
      {
        list.push(this.$t("DQ.list_Wellness35") + " = " + this.$t("DQ.yes"));
        //SYMPTOM - Chest pain
      }
      if(this.input.sec3SymptomWetCoughProductive == true ||
            this.input.sec3SymptomWetCoughNonProductive == true ||
            this.input.sec3SymptomDryCough == true ||
            this.input.sec3SymptomSoreThroat == true ||
            this.input.sec3SymptomCongestionRunningNose == true ||
            this.input.sec3SymptomShortnessOfBreath == true ||
            this.input.sec3SymptomChills == true ||
            this.input.sec3SymptomHeadache == true ||
            this.input.sec3SymptomLossOfSmell == true ||
            this.input.sec3SymptomLossOfTaste == true ||
            this.input.sec3SymptomLossOfAppetite == true ||
            this.input.sec3SymptomPinkEye == true ||
            this.input.sec3SymptomBodyAchesPain == true ||
            this.input.sec3SymptomSuddenConfusion == true ||
            this.input.sec3SymptomDigestiveSystem == true ||
            this.input.sec3SymptomFatigue == true ||
            this.input.sec3SymptomChestPain == true)
      {
        if(this.input.sec3SymptomStartDate != "1900-01-01")
        {
          list.push(this.$t("DQ.list_Wellness36") + " = "  + new Date(this.input.sec3SymptomStartDate).toLocaleDateString());
          //SYMPTOM - When did you start to feel the symptoms?
        }
      }

      // PANDEMIC
      //Q1 DIAGNOSED
      if(this.input.sec4PanCurrentlyHaveC19 == true)
      {
        list.push(this.$t("DQ.list_Pandemic1") + " = " + this.$t("DQ.no"));
        //PANDEMIC - Is your COVID-19 Profile information with us up to date?
      }
      //Q2 PREVOUS INFECTION
      if(this.input.sec4PanPrevTestedPositiveForC19 == true)
      {
        list.push(this.$t("DQ.list_Pandemic2") + " = " + this.$t("DQ.yes"));
        //PANDEMIC - Have you previously tested positive (with antibody or nasal swab test) for COVID-19?
      }
      if(this.input.sec4PanPrevTestedPositiveForC19A == true)
      {
        list.push(this.$t("DQ.list_Pandemic3") + " = " + this.$t("DQ.yes"));
        //PANDEMIC - At least 10 days have passed from the onset of symptoms and no subsequent illness.
       }
      if(this.input.sec4PanPrevTestedPositiveForC19B == true)
      {
        list.push(this.$t("DQ.list_Pandemic4") + " = " + this.$t("DQ.yes"));
        //PANDEMIC - There have been 3 days without fever and without the use of fever reducing medications.
      }
      if(this.input.sec4PanPrevTestedPositiveForC19C == true)
      {
        list.push(this.$t("DQ.list_Pandemic5") + " = " + this.$t("DQ.yes"));
        //PANDEMIC - Respiratory symptoms: cough and/or shortness of breath have resolved.
      }
      //Q3 CLOSE CONTACT
      if(this.input.sec4PanContactWithC19DiagnosedPerson == true)
      {
        list.push(this.$t("DQ.list_Pandemic6") + " = " + this.$t("DQ.yes"));
        //PANDEMIC - Have you had close or direct contact with a person diagnosed with COVID-19 in the past 14 days?
      }
      if(this.input.sec4PanContactWithC19DiagnosedPersonExplain.length > 0)
      {
        list.push(this.$t("DQ.list_Pandemic7") + " = " + this.$t("DQ.yes"));
        //PANDEMIC - Question 3, Explanation provided.
      }
      if(this.input.sec4PanContactWithC19Traveler == true)
      {
        list.push(this.$t("DQ.list_Pandemic8") + " = " + this.$t("DQ.yes"));
        //PANDEMIC - Have you had close or direct contact with someone who has travelled to another country in the past 14 days?
      }
      if(this.input.sec4PanContactWithC19TravelerCountryId > 0)
      {
        list.push(this.$t("DQ.list_Pandemic9") + " = " + this.$t("DQ.yes"));
        //PANDEMIC - Question 4, Country provided.
      }
      if(this.input.sec4PanContactWithC19TravelerExplain.length > 0)
      {
        list.push(this.$t("DQ.list_Pandemic10") + " = " + this.$t("DQ.yes"));
        //PANDEMIC - Question 4, Explanation provided.
      }
      if(this.input.sec4PanChronicConditions == true)
      {
        list.push(this.$t("DQ.list_Pandemic11") + " = " + this.$t("DQ.yes"));
        //PANDEMIC - Do you have any chronic medical conditions?
      }
      if(this.input.sec4PanChronicConditionsExplain.length > 0)
      {
        list.push(this.$t("DQ.list_Pandemic12") + " = " + this.$t("DQ.yes"));
        //PANDEMIC - Question 5, List provided.
      } 
      if(this.input.sec4PanCompromisedImmunity == true)
      {
        list.push(this.$t("DQ.list_Pandemic13") + " = " + this.$t("DQ.yes"));
        //PANDEMIC - Do you have any compromised immunity issues?
      } 
      if(this.input.sec4PanCompromisedImmunityExplain.length > 0)
      {
        list.push(this.$t("DQ.list_Pandemic14") + " = " + this.$t("DQ.yes"));
        //PANDEMIC - Do you have any compromised immunity issues?
      }
      return list;
    },
    submit2()
    {
      try
      {

         
       /* this.isLoading = true;

        // VALIDATE INPUT RULES
        if(!this.validate())
        {
          this.isLoading = false;
          return;
        } */
       
        API.createDailyQuestionnaire(
            window.sessionKey,
            this.input.dailyQuestionnaireTypeId,
            Number(this.input.sec1MoodRating),
            this.input.sec2IllnessFeelingSick,
            this.input.sec2IllnessInterfereWithDuties,
            this.input.sec2IllnessExplanation,
            this.input.sec2StressFeelingStress ,
            this.input.sec2StressLongWorkloadHours,
            this.input.sec2StressWorkplaceChallenges,
            this.input.sec2StressPersonalCauses,
            this.input.sec2StressExplanation,
            this.input.sec2AlcoholWithinPast24Hours,
            Number(this.input.sec2AlcoholHoursSinceLastDrink),
            this.input.sec2FatigueExperiencing,
            this.input.sec2FatigueMuscular,
            this.input.sec2FatigueMental,
            this.input.sec2FatigueEmotional,
            this.input.sec2FatigueLackOfSleep,
            this.input.sec2FatigueChronicLackOfSleep,
            this.input.sec2FatigueExplanation,
            this.input.sec2EmotionRecentTrauma,
            this.input.sec2EmotionExplanation,
            this.input.sec3MentalHealthFeelingToday,
            this.input.sec3MentalHealthPast2Weeks,
            Number(this.input.sec3MentalHealthNervouseAnxious),
            Number(this.input.sec3MentalHealthWorrying),
            Number(this.input.sec3MentalHealthNoInterest),
            Number(this.input.sec3MentalHealthDepressed),
            Number(this.input.sec3MentalHealthSuicidalHomicidal),
            this.input.sec3FatigueWakeRestful,
            Number(this.input.sec3FatigueHoursOfSleep),
            this.input.sec3FatigueSleepSameTime,
            this.input.sec3FatigueUseCPAP,
            this.input.sec3FatigueUseCPAPDuringLastSleep,
            this.input.sec3FatigueCPAPRequired,
            this.input.sec3InstructionsFollowingDoctorOrders,
            this.input.sec3MedsTakingAny,
            this.input.sec3MedsTakingAsPrescribed,
            this.input.sec3MedsStateOfMind,
            this.input.sec3MedsInterfereWithJob,
            this.input.sec3MedsTakingSupplements,
            this.input.sec3MedsExplanation,
            this.input.sec3AccommodationNeeded,
            this.input.sec3AccomodationJobAppAdjustment,
            this.input.sec3AccommodationScheduleModification,
            this.input.sec3AccommodationEqualBenefitsChange,
            this.input.sec3AccommodationDoctorsAppointment,
            this.input.sec3OtherBotheringYou,
            this.input.sec3OtherExplanation,
            Number(this.input.sec3TempValue),
            this.input.sec3TempPastNDays,
            this.input.sec3TempUsedDigitalThermometer,
            this.input.sec3SymptomWetCoughProductive,
            this.input.sec3SymptomWetCoughNonProductive,
            this.input.sec3SymptomDryCough,
            this.input.sec3SymptomSoreThroat,
            this.input.sec3SymptomCongestionRunningNose,
            this.input.sec3SymptomShortnessOfBreath,
            this.input.sec3SymptomChills,
            this.input.sec3SymptomHeadache,
            this.input.sec3SymptomLossOfSmell,
            this.input.sec3SymptomLossOfTaste,
            this.input.sec3SymptomLossOfAppetite,
            this.input.sec3SymptomPinkEye,
            this.input.sec3SymptomBodyAchesPain,
            this.input.sec3SymptomSuddenConfusion,
            this.input.sec3SymptomDigestiveSystem,
            this.input.sec3SymptomFatigue,
            this.input.sec3SymptomChestPain,
            this.input.sec3SymptomStartDate + 'T00:00:00.000',
            this.input.sec4PanProfileUpToDate,
            this.input.sec4PanCurrentlyHaveC19,
            this.input.sec4PanPrevTestedPositiveForC19,
            this.input.sec4PanPrevTestedPositiveForC19A,
            this.input.sec4PanPrevTestedPositiveForC19B,
            this.input.sec4PanPrevTestedPositiveForC19C,
            this.input.sec4PanContactWithC19DiagnosedPerson,
            this.input.sec4PanContactWithC19DiagnosedPersonExplain,
            this.input.sec4PanContactWithC19Traveler,
            Number(this.input.sec4PanContactWithC19TravelerCountryId),
            this.input.sec4PanContactWithC19TravelerExplain,
            this.input.sec4PanChronicConditions,
            this.input.sec4PanChronicConditionsExplain,
            this.input.sec4PanCompromisedImmunity,
            this.input.sec4PanCompromisedImmunityExplain,
            this.input.vaccination,
            Number(this.input.vaccineId),
            ((this.input.vaccineDose1) == '' ? '1900-01-01T00:00:00.000' : this.input.vaccineDose1),
            ((this.input.vaccineDose2) == '' ? '1900-01-01T00:00:00.000' : this.input.vaccineDose2),
            ((this.input.vaccineDose3) == '' ? '1900-01-01T00:00:00.000' : this.input.vaccineDose3)
          )
          .then(response => {
            if(response.data.hasError == true)
            {
              
              //alert(response.data.errorMessage);
              this.$generalMessage(messageBox, response.data.errorMessage);
              if(response.data.errorId == "4000")
              {
                SUPPORT.clearSession();
                this.$router.push( { path: "/"} );
                this.input.isLoading = false;
                return;
              }
            }
            else
            {
              //alert("Your daily COVID-19 questionnaire has been successfully submitted.")
              this.$generalMessage(messageBox, this.$t("DQ.hasBeenSubmitted")); /*"Your daily COVID-19 questionnaire has been successfully submitted.");*/
              
              // LOG THE SESSION OUT HERE
              API.logoff(window.sessionKey);
              window.sessionKey = '';

              // REDIRECT TO THE HOME PAGE
              this.$router.push( { path: "/"} );

            }
          }).catch( error =>
          {
            //alert( error );
            this.$generalMessage(messageBox, error );
            this.$router.push( { path: "/"} );
            
          })
          this.input.isLoading = false;
      }
      catch(e)
      {
        //alert(e);
        this.input.isLoading = false;
        this.$generalMessage(messageBox, e);
      }
    },
    onfeelingTodayFine()
    { 
      //this.input.sec3MentalHealthFeelingToday = (val == true ) ? false: true;
      this.input.sec3MentalHealthPast2Weeks = false;
      this.input.sec3MentalHealthNervouseAnxious = 0;
      this.input.sec3MentalHealthWorrying = 0;
      this.input.sec3MentalHealthNoInterest = 0;
      this.input.sec3MentalHealthDepressed = 0;
      this.input.sec3MentalHealthSuicidalHomicidal = 0;
      this.input.sec3InstructionsFollowingDoctorOrders = true;
      this.input.sec3AccommodationNeeded = false;
      this.input.sec3AccomodationJobAppAdjustment = false;
      this.input.sec3AccommodationScheduleModification = false;
      this.input.sec3AccommodationEqualBenefitsChange = false;
      this.input.sec3AccommodationDoctorsAppointment = false;
      this.input.sec3OtherBotheringYou = false;
      this.input.sec3OtherExplanation = "";
      this.input.sec3TempValue = "";
      this.input.sec3TempPastNDays = false;
      this.input.sec3TempUsedDigitalThermometer = false;
      this.input.sec3SymptomWetCoughProductive = false;
      this.input.sec3SymptomWetCoughNonProductive = false;
      this.input.sec3SymptomDryCough = false;
      this.input.sec3SymptomSoreThroat = false;
      this.input.sec3SymptomCongestionRunningNose = false;
      this.input.sec3SymptomShortnessOfBreath = false;
      this.input.sec3SymptomChills = false;
      this.input.sec3SymptomHeadache = false;
      this.input.sec3SymptomLossOfSmell = false;
      this.input.sec3SymptomLossOfTaste = false;
      this.input.sec3SymptomLossOfAppetite = false;
      this.input.sec3SymptomPinkEye = false;
      this.input.sec3SymptomBodyAchesPain = false;
      this.input.sec3SymptomSuddenConfusion = false;
      this.input.sec3SymptomDigestiveSystem = false;
      this.input.sec3SymptomFatigue = false;
      this.input.sec3SymptomChestPain = false;
      this.input.sec3SymptomStartDate = "";
    },
    onMH1FeelingTodayWeeks()
    {
      this.input.sec3MentalHealthNervouseAnxious = 0;
      this.input.sec3MentalHealthWorrying = 0;
      this.input.sec3MentalHealthDepressed = 0;
      this.input.sec3MentalHealthSuicidalHomicidal = 0;
    },
    onMH2WakeRestful()
    {
      this.input.sec3FatigueHoursOfSleep = 0;
      this.input.sec3FatigueSleepSameTime = true;
    },
    onMH5Accommodations()
    {
      this.input.sec3AccomodationJobAppAdjustment = false;
      this.input.sec3AccommodationScheduleModification = false;
      this.input.sec3AccommodationEqualBenefitsChange = false;
      this.input.sec3AccommodationDoctorsAppointment = false;
    },
    onMH6Other()
    {
      this.input.sec3OtherExplanation = "";
    },
    onPreviousTestedPositiveC19()
    {
      this.input.sec4PanPrevTestedPositiveForC19A = false;
      this.input.sec4PanPrevTestedPositiveForC19B = false;
      this.input.sec4PanPrevTestedPositiveForC19C = false;
    },
    onContactWithC19DiagnosedPerson()
    {
      this.input.sec4PanContactWithC19DiagnosedPersonExplain = "";
    },
    onContactWithC19Traveler()
    {
      this.input.sec4PanContactWithC19TravelerCountryId = 0;
      this.input.sec4PanContactWithC19TravelerExplain = "";
    },
    onChronicConditions()
    {
      this.input.sec4PanChronicConditionsExplain = "";
    },
    onCompromisedImmunity()
    {
      this.input.sec4PanCompromisedImmunityExplain = "";
    },
    onSec2IllnessFeelingSick()
    {
      this.input.sec2IllnessInterfereWithDuties = false;
      this.input.sec2IllnessExplanation = "";
    },
    onSec3MedsTakingAll()
    {
      this.input.sec3MedsTakingAsPrescribed = true;
      this.input.sec3MedsStateOfMind = false;
      this.input.sec3MedsInterfereWithJob = false;
      this.input.sec3MedsTakingSupplements = false;
    },
    onSec3FatigueUseCPAP()
    {
      this.input.sec3FatigueUseCPAPDuringLastSleep = false;  
      this.input.sec3FatigueCPAPRequired = false;    
    },
    onSec2FatigueExperiencing()
    {
      this.input.sec2FatigueMuscular = false;
      this.input.sec2FatigueMental = false;
      this.input.sec2FatigueEmotional = false;
      this.input.sec2FatigueExplanation = "";

    },
    onVaccination()
    {
      /* this.input.vaccineId = 0;
      this.input.vaccineDose1 = "";
      this.input.vaccineDose2 = "";
      this.input.vaccineDose3 = ""; */
    },
    onSec2IllnessInterfereWithDuties()
    {
      this.input.sec2IllnessExplanation = "";
    },
    onSec2StressFeelingStress()
    {
      this.input.sec2StressLongWorkloadHours = false;
      this.input.sec2StressWorkplaceChallenges = false;
      this.input.sec2StressPersonalCauses = false;
      this.input.sec2StressExplanation = "";
    },
    onSec2AlcoholWithinPast24Hours()
    {
      this.input.sec2AlcoholHoursSinceLastDrink = 0;
    },
    onSec2EmotionRecentTrauma()
    {
      this.input.sec2EmotionExplanation = "";
    },
    validate()
    {
      var dateNow = new Date();
      var dDate1;
      var dDate2;
      var dDate3;
      var defaultDate;

      // AGREEMENT
      if(!this.input.agreement)
      {
        this.$generalMessage(messageBox, this.$t("DQ.mustAgree")); //"You must agree to the terms to continue.");
        return false;
      }

      // SECION 1 - MOOD
      if(this.input.sec1MoodRating == 0)
      {
        this.$generalMessage(messageBox, this.$t("DQ.rule_Mood1")); //Please your mood rating from SECTION 1.
        return false;
      }

      // SECTION 2 - PRE-WORK SHIFT MEDICAL CHECKLIST
      if(this.input.sec2IllnessInterfereWithDuties == true)
      {
        if(this.input.sec2IllnessExplanation.length == 0)
        {
          this.$generalMessage(messageBox, this.$t("DQ.rule_Illness1")); //Please enter an explanation for ILLNESS in SECTION2.
          return false;
        }
      }
      if(this.input.sec3MedsTakingAny == true)
      {
        if(this.input.sec3MedsExplanation.length == 0)
        {
          this.$generalMessage(messageBox, this.$t("DQ.rule_Meds1")); //Please enter your medication listing for MEDICATION in SECTION2.
          return false;
        }
      }
      if(this.input.sec2StressFeelingStress == true)
      {
        if((this.input.sec2StressLongWorkloadHours == true) ||
          (this.input.sec2StressWorkplaceChallenges == true) ||
          (this.input.sec2StressPersonalCauses))
          {
            if(this.input.sec2StressExplanation.length == 0)
            {
              this.$generalMessage(messageBox, this.$t("DQ.rule_Stress1")); //Please enter your stress condition details for STRESS in SECTION2.
              return false;
            }
          }
      }
      // SECTION 2 - ALCOHOL
      if(this.input.sec2AlcoholWithinPast24Hours == true)
      {
        if(this.input.sec2AlcoholHoursSinceLastDrink == 0)
        {
          this.$generalMessage(messageBox, this.$t("DQ.rule_Alcohol1")); //Please enter the number of hours since you had your last drink for ALCOHOL in SECTION2.
          return false;
        }
      }

      // SECTION 2 - FATIGUE
      if((this.input.sec2FatigueExperiencing == true) ||
        (this.input.sec2FatigueMental == true) ||
        (this.input.sec2FatigueEmotional == true)) 
      {
        if(this.input.sec2FatigueExplanation.length == 0)
        {
          this.$generalMessage(messageBox, this.$t("DQ.rule_Fatigue1")); //Please enter details about your fatigue for FATIGUE in SECTION2.
          return false;              
        }
      }

      // SECTION 2 - SLEEP
      if(this.input.sec3FatigueHoursOfSleep == 0)
      {
        this.$generalMessage(messageBox, this.$t("DQ.rule_Sleep1")); //Please how many hours of sleep you have had prior to your upcomming work shift for SLEEP in SECTION2.
        return false;   
      }
      
      // SECTION 2 - EMOTION
      if(this.input.sec2EmotionRecentTrauma == true)
      {
        if(this.input.sec2EmotionExplanation.length == 0)
        {
          this.$generalMessage(messageBox, this.$t("DQ.rule_Emotion1")); //Please your details for EMOTION in SECTION2.
          return false;   
        }
      }

      // SECTION 3 - MEDICAL WELLNESS
      if(this.input.sec3MentalHealthFeelingToday == true) // NOT GREAT
      {
        // SECTION 5 MENTAL HEALTH
        // ANXIETY/DEPRESSSION
        if(this.input.sec3MentalHealthPast2Weeks == true)
        {
          if(this.input.sec3MentalHealthNervouseAnxious == 0)
          {
            this.$generalMessage(messageBox, this.$t("DQ.rule_MentalHealth1")); //Please select an answer to "Feeling nervous, anxious or on edge" for MEDICAL WELLNESS in SECTION 3.
            return false;   
          }
          if(this.input.sec3MentalHealthWorrying == 0)
          {
            this.$generalMessage(messageBox, this.$t("DQ.rule_MentalHealth2")); //Please select an answer to "Not being able to stop or control worrying" for MEDICAL WELLNESS in SECTION 3.
            return false;   
          }
          if(this.input.sec3MentalHealthNoInterest == 0)
          {
            this.$generalMessage(messageBox, this.$t("DQ.rule_MentalHealth3")); //Please select an answer to "Little interest or pleasure in doing things" for MEDICAL WELLNESS in SECTION 3.
            return false;
          }
          if(this.input.sec3MentalHealthDepressed == 0)
          {
            this.$generalMessage(messageBox, this.$t("DQ.rule_MentalHealth4")); //Please select an answer to "Feeling down, depressed, or hopeless" for MEDICAL WELLNESS in SECTION 3.
            return false;
          }
          if(this.input.sec3MentalHealthSuicidalHomicidal == 0)
          {
            this.$generalMessage(messageBox, this.$t("DQ.rule_MentalHealth5")); //Please select an answer to "Feeling Suicidal or Homicidal" for MEDICAL WELLNESS in SECTION 3.
            return false;
          }
        }
      
        // ACCOMMODATIONS
        if(this.input.sec3AccommodationNeeded == true)
        {
          if((this.input.sec3AccomodationJobAppAdjustment == false) &&
            (this.input.sec3AccommodationScheduleModification == false) &&
            (this.input.sec3AccommodationEqualBenefitsChange == false) &&
            (this.input.sec3AccommodationDoctorsAppointment == false))
          {
            this.$generalMessage(messageBox, this.$t("DQ.rule_Accommodations1")); //Please select at least one accommodtaion for ACCOMMODATIONS in SECTION 3.
            return false;
          }
        }
        if(this.input.sec3OtherBotheringYou == true)
        {
          if(this.input.sec3OtherExplanation.length == 0)
          {
            this.$generalMessage(messageBox, this.$t("DQ.rule_BotheringYou1")); //Please enter an explanation for what is bothering you in SECTION 3.
            return false;
          }
        }

        if(!parseFloat(this.input.sec3TempValue))
        {
          this.$generalMessage(messageBox, this.$t("DQ.rule_Temperature1")); //Please enter a temperature for TEMPERATURE in SECTION 3.
          return false;
        }
        if(isNaN(this.input.sec3TempValue))
        {
          this.$generalMessage(messageBox, this.$t("DQ.rule_Temperature2")); //Please enter a valid temperature for TEMPERATURE in SECTION 3.
          return false;
        }
        if(parseFloat(this.input.sec3TempValue) <= 95.5)
        {
          this.$generalMessage(messageBox, this.$t("DQ.rule_Temperature3")); //Temperature cannot be below 95.5. for TEMERATURE in SECTION 3.);
          return false;
        }
        if(parseFloat(this.input.sec3TempValue) >= 116)
        {
          this.$generalMessage(messageBox, this.$t("DQ.rule_Temperature4")); //Temperature cannot be greater than 116. for TEMERATURE in SECTION 3.);
          return false;
        }

        // ROUND TO 2 DECIMAL PLACES
        this.input.sec3TempValue = +(Math.round(this.input.sec3TempValue + "e+2")  + "e-2")
      
        // SYMPTOMS
        if(this.input.sec3SymptomWetCoughProductive ||
          this.input.sec3SymptomWetCoughNonProductive ||
          this.input.sec3SymptomDryCough ||
          this.input.sec3SymptomSoreThroat ||
          this.input.sec3SymptomCongestionRunningNose ||
          this.input.sec3SymptomShortnessOfBreath ||
          this.input.sec3SymptomChills ||
          this.input.sec3SymptomHeadache ||
          this.input.sec3SymptomLossOfSmell ||
          this.input.sec3SymptomLossOfTaste ||
          this.input.sec3SymptomLossOfAppetite ||
          this.input.sec3SymptomPinkEye ||
          this.input.sec3SymptomBodyAchesPain ||
          this.input.sec3SymptomSuddenConfusion ||
          this.input.sec3SymptomDigestiveSystem ||
          this.input.sec3SymptomFatigue ||
          this.input.sec3SymptomChestPain)
        { 
          if(this.input.sec3SymptomStartDate == "")
          {
            //alert('You must enter a symptom start date to continue.');
            this.$generalMessage(messageBox, this.$t("DQ.rule_Symptom1")); //You must enter a symptom start date to continue.
            return false;
          }
          else
          {
            if(this.input.sec3SymptomStartDate.length != 10)
            {
              this.$generalMessage(messageBox, this.$t("DQ.rule_Symptom2")); //Symptom Start Date must be in the format XX/XX/XXXX.
              return false;
            }
            
            var ssDate = new Date(this.input.sec3SymptomStartDate);
            
            // MUST BE A PAST DATE
            if(ssDate > dateNow)
            {
              this.$generalMessage(messageBox, this.$t("DQ.rule_Symptom3")); //Symptom start date cannot be in the future.
              return false;
            }
            
            this.input.symptomStartDate = this.input.symptomStartDate; //+ 'T00:00:00.000';          
          }
        }
        else
        {
          this.input.sec3SymptomStartDate = "1900-01-01";
        }
      }
      else
      {
        this.input.sec3SymptomStartDate = "1900-01-01";
      }

      // SECTION 4 - PANDEMIC
      if(this.input.sec4PanProfileUpToDate == false)
      {
        if(this.input.sec4PanContactWithC19DiagnosedPerson)
        {
          if(this.input.sec4PanContactWithC19DiagnosedPersonExplain.length == 0)
          {
            this.$generalMessage(messageBox, this.$t("DQ.rule_Pandemic1")); //Please enter an explantion for CLOSE/DIRECT CONTACT in SECTION 3.
            return false;
          }
        }
        if(this.input.sec4PanContactWithC19Traveler == true)
        {
          if(this.input.sec4PanContactWithC19TravelerCountryId == 0 )
          {
            this.$generalMessage(messageBox, this.$t("DQ.rule_Pandemic2")); //Please select a country for TRAVELER in SECTION 4.
            return false;
          }
          if(this.input.sec4PanContactWithC19TravelerExplain.length == 0)
          {
            this.$generalMessage(messageBox, this.$t("DQ.rule_Pandemic3")); //Please enter an explantion for CLOSE/DIRECT TRAVELER in SECTION 4.
            return false;
          }
        }
      
        if(this.input.sec4PanChronicConditions == true)
        {
          if(this.input.sec4PanChronicConditionsExplain == "")
          {
            this.$generalMessage(messageBox, this.$t("DQ.rule_Pandemic4")); //Please enter an explantion for CHRONIC CONDITIONS in SECTION 4.
            return false;
          }
        }
      
        if(this.input.sec4PanCompromisedImmunity == true)
        {
          if(this.input.sec4PanCompromisedImmunityExplain == "")
          {
            this.$generalMessage(messageBox, this.$t("DQ.rule_Pandemic5")); //Please enter an explantion for COMPROMISED IMMUNITY in SECTION 4.
            return false;
          }
        }
      }

      // -- SECTION 5 - VACCINATIONS
      if(this.input.vaccination == false)
      {
        if( this.input.vaccineId <= 0 )
        {
          this.$generalMessage(messageBox, this.$t("DQ.enterVaccine"));
          return false;
        }
        /* PFIZER/MODERNA */
        else if((this.input.vaccineId == 1) || (this.input.vaccineId == 2)) 
        {
          // MUST BE A PAST DATE
          dDate1 = new Date(this.input.vaccineDose1);
          dDate2 = new Date(this.input.vaccineDose2);
          dDate3 = new Date(this.input.vaccineDose3);
          defaultDate = new Date("1900-01-01T00:00:00").getTime();

          // CHECK FOR ALL BLANKS
          if((dDate1.getTime() == defaultDate) &&
                  (dDate2.getTime() == defaultDate) &&
                  (dDate3.getTime() == defaultDate) )
          {
            this.$generalMessage(messageBox, this.$t("DQ.vaccineDoseEmpty")); 
            return false;
          }

          // CHECK FUTURE DATES
          if(dDate1 > dateNow)
          {
            this.$generalMessage(messageBox, this.$t("DQ.vaccineDose1Future")); 
            return false;
          }
          else if(dDate2 > dateNow)
          {
            this.$generalMessage(messageBox, this.$t("DQ.vaccineDose2Future")); 
            return false;
          }
          else if(dDate3 > dateNow)
          {
            this.$generalMessage(messageBox, this.$t("DQ.vaccineDose3Future")); 
            return false;
          }
          
          // CHECK FOR PROPER DOSE DATE ORDER
          if(dDate2.getTime() != defaultDate)
          {
            // CHECKING DOSE 2
            if(dDate1 > dDate2)
            { 
              this.$generalMessage(messageBox, this.$t("DQ.vaccineDose1GreaterThanDose2")); 
              return false;
            }
          }
          else if(dDate3.getTime() != defaultDate)
          {
            // CHECKING DOSE 3
            if(dDate2 > dDate3)
            { 
              this.$generalMessage(messageBox, this.$t("DQ.vaccineDose2GreaterThanDose3")); 
              return false;
            }
          }
          
          // CHECK FOR VACCINATION PRIOR TO BOOSTER
          if((dDate1.getTime() == defaultDate) || 
            (dDate2.getTime() == defaultDate) ) 
          {
            if(dDate3.getTime() != defaultDate) 
            {
              this.$generalMessage(messageBox, this.$t("DQ.vaccineDose1Or2Missing")); 
              return false;
            }
          }
        }
        // Johnson & Johnson
        else if(this.input.vaccineId == 3) 
        {
          dDate1 = new Date(this.input.vaccineDose1);
          dDate3 = new Date(this.input.vaccineDose3);
          defaultDate = new Date("1900-01-01T00:00:00").getTime();

          // CHECK FUTURE DATES
          if(dDate1 > dateNow)
          {
            this.$generalMessage(messageBox, this.$t("DQ.vaccineDose1Future")); 
            return false;
          } 
          else if(dDate3 > dateNow)
          {
            this.$generalMessage(messageBox, this.$t("DQ.vaccineDose3Future")); 
            return false;
          } 
          
          // CHECK DATE ORDER
          if(dDate3.getTime() != defaultDate)
          {
            if(dDate1 >= dDate3)
            { 
              this.$generalMessage(messageBox, this.$t("DQ.vaccineDose1GreaterThanDose2")); 
              return false;
            }
          }
        }
      }

      return true;
    },
  },
}
</script>


<style lang="scss" scoped>
@import "../../../assets/styles/global.css";

// DISABLE WIDESCREEN BREAKPOINT
$widescreen-enabled: false;

// DISABLE FULLHD BREAKPOINT
$fullhd-enabled: false;

// BEGIN SHARED STYLES
p {
  white-space: pre;
}
.disabled {
  background-color:darkgray;
}

.enabled {
  background-color: white;
}
// END SHARED STYLES

//////////////////////////////////////////
// MOBILE
@media only screen and 
(min-width : 320px) and (max-width : 1023px)
{
  // NOT WORKING
  /* @-ms-viewport{
    width: device-width;
  } */

  #main-table-screen
  {
    max-width: 100%;
    width:100%;
    background-color:gray;
    padding: 0px;
    margin: 0px;
    margin-bottom:15px;
    display:table;
  }
  #main-table-row1
  {
    height:15px; 
  }
  #main-table-row2-dialog-container-td
  {
    margin:auto;
  }

  // BEGIN TABLE STYLES
  table { // KEY, FIXES TABLE TO MOBILE WIDTH
    table-layout:fixed;
  }
  .dialog-table
  {
    width:96%;
  }
  #dialog-td-title
  {
    width:100%;
    height:75px;
    background-color:#4682B4;
    color:white;
    font-family:'Arial Black';
    font-size: 17pt;
    font-style:italic;
    font-weight: bold;    
    padding-bottom:0px;
    margin-bottom:0px;
    vertical-align: middle;
  }
  #dialog-td-instructions
  {
    width:100%;
    word-wrap:break-word !important;
    background-color:#4682B4;
    color:white;
    font-family:'Arial';
    font-size: 11pt;
    font-style:italic;
    padding-left:10px;
    padding-right:10px;
    vertical-align: middle;
  }
  .dialog-signon-td-section-title
  {
    width:100%;
    height:47px;
    background-color:darkgray;//#4682B4;
    color:white;
    font-family:'Arial Black';
    font-size: 12pt;
    font-style:italic;
    font-weight: bold;
    padding-left:5px;
    padding-right:5px;
    padding-bottom:0px;
    margin-bottom:0px;
    vertical-align: bottom;
  }
  .dialog-question-space
  {
    width:0px;
    height:0px;
    background-color:#343F68;
    color:white;
  }
  .dialog-question-space-alt
  {
    width:0px;
    height:0px;
    background-color:#343F68;
    color:white;
  }
  .dialog-question
  {
    height:100%;
    width:100%;//300px;
    padding-left:5px;
    padding-right:5px;
    background-color:#343F68;
    color:white;
    word-wrap:break-word !important
  }
  .dialog-input-field-right
  {
    width:100%;
    height:auto; //25px;
    vertical-align: top;
    background-color:#343F68;
    color:white;
    text-align: right;
    padding-right:25px;
  }
  .dialog-input-field-right-alt
  {
    width:100%;
    height:25px;
    vertical-align: top;
    background-color:#343F68;
    color:white;
    text-align: right;
    padding-right:25px;
  }
  .dialog-sub-question 
  {
    padding-left:5px;
    padding-right:5px;
    background-color:#343F68;
    color:white;
    vertical-align:top;
  }
  .dialog-sub-question-alt
  {
    padding-left:5px;
    padding-right:5px;
    background-color:#343F68;
    color:white;
    vertical-align:top;
  }
   .dialog-sub-question-div
  {
    width:0px;
  }
  
  .dialog-input-field-explain
  {
    height:40px;
    vertical-align: middle;
    background-color:#343F68;
    color:white;
    padding-left:5px;
    padding-right:5px;
    //padding-bottom: 70px;
    //margin-bottom: 40px;
    width: 100%;//300px;
    resize:none;
    text-align: right;
  }
  .dialog-input-field-explain-alt
  {
    height:40px;
    vertical-align: middle;
    background-color:#343F68;
    color:white;
    padding-left:5px;
    padding-right:5px;
    //padding-bottom: 70px;
    //margin-bottom: 40px;
    width: 100%;//300px;
    resize:none;
    text-align: right;
  }
  .dialog-input-submit
  {
    height:50px;
    padding-top:10px;
    vertical-align:middle !important;
    background-color:darkgray;//#343F68;
    color:white;
  }
  .mood
  {
    padding-right:25px;
    color:white;
    text-align: right;
    background-color:#343F68;
  }
  #mood-1
  {
    width:100%;
    color:white;
    background-color:#343F68;
  }
  #mood-2
  {
    width:100%;
    color:white;
    background-color:#343F68;
  }
  // END TABLE STYLES

  // BEGIN DOT STYLES
 /* .border-dots
 {
    //border-bottom-style:none;
    border-bottom-style:dashed;
    border-bottom-width:1px !important;
    border-bottom-color:lightgray;//#4682B4 !important;
 } */
 .border-dots
 {
    border-bottom-style:dashed;
    border-bottom-width:1px !important;
    border-bottom-color:#4682B4 !important;
 }
 .border-dots-inner
 {
    border-bottom-style:none;
 }
 // END DOT STYLES
 
 // BEGIN CORNER STYLES
 .radius-single-left-field-left-top
  {
    border-top-left-radius:15px;
    overflow:hidden;
  }
  .radius-single-left-field-left-bottom
  {
    //border-bottom-left-radius:15px;
    overflow:hidden;
  } 
 .radius-single-left-field-right-top
  {
    border-top-right-radius:15px;
    overflow:hidden;
  }
  .radius-single-left-field-right-bottom
  {
    //border-bottom-right-radius:15px;
    overflow:hidden;
  }
  .radius-single-right-field-left-top
  {
    //border-top-left-radius:15px;
    overflow:hidden;
  }
  .radius-single-right-field-left-bottom
  {
    border-bottom-left-radius:15px;
    overflow:hidden;
  }
  .radius-single-right-field-right-top
  {
    //border-top-right-radius:15px;
    overflow:hidden;
  }
  .radius-single-right-field-right-bottom
  {
    border-bottom-right-radius:15px;
    overflow:hidden;
  }

  // TOP ROW
  .radius-top-left-field-top
  {
    border-top-left-radius:15px;
    overflow:hidden;
  }
  .radius-top-left-field-bottom
  {
    //border-bottom-left-radius:15px;
    overflow:hidden;
  } 
  .radius-top-right-field-top
  {
    border-top-right-radius:15px;
    overflow:hidden;
  }
  .radius-top-right-field-bottom
  {
    //border-bottom-right-radius:15px;
    overflow:hidden;
  } 

  // BOTTOM ROW
  .radius-bottom-left-field-top
  {
    //border-top-left-radius:15px;
    overflow:hidden;
  }
  .radius-bottom-left-field-bottom
  {
    border-bottom-left-radius:15px;
    overflow:hidden;
  } 
  .radius-bottom-right-field-top
  {
    //border-top-right-radius:15px;
    overflow:hidden;
  }
  .radius-bottom-right-field-bottom
  {
    border-bottom-right-radius:15px;
    overflow:hidden;
  } 

  // END CORNER STYLES

  // BEGIN OTHER STYLES
  .wrap
  {
    word-wrap:break-word !important;
    white-space: normal;
  }
  .col4-width
  {
    width:100% !important;
  }
  #main-table-row3
  {
    height:30px;
  }
  #country select
  {
    width:100px
  }
  #country select:focus
  {
    width:auto;
  }
  // END OTHER STYLES
  
  // BEGIN FOOTER STYLES
  .section-footer
  {
    height:10px;
    background-color:#343F68;
    color:white;
    vertical-align:top;
    //width:100%;
  }
  // END FOOTER STYLES

}

//////////////////////////////////////////
// DESKTOP
@media screen and (min-width:1024px)  
{
  #main-table-screen
  {
    width:100%;
    max-width:100%;
    min-width:100%;
    background-color:gray;
    padding: 0px;
    margin: 0px;
    margin-bottom:0px;
    display:table;    
  }
  #main-table-row1
  {
    height:50px; 
  }
  #main-table-row2-dialog-container-td
  {
    margin:auto;
  }
  // BEGIN TABLE STYLES
  .dialog-table
  {
    width:98%;
  }
  #dialog-td-title
  {
    width:20%;
    height:50px;
    background-color:#4682B4;
    color:white;
    font-family:'Arial Black';
    font-size: 17pt;
    font-style:italic;
    font-weight: bold;
    padding-bottom:0px;
    margin-bottom:0px;
    vertical-align: middle;   
  }
  #dialog-td-instructions
  {
    word-wrap:break-word !important;
    background-color:#4682B4;
    color:white;
    font-family:'Arial';
    font-size: 11pt;
    font-style:italic;
    padding-left:30px;
    padding-right:30px;
    vertical-align: middle;
  }
  .dialog-signon-td-section-title
  { 
    width:100%;
    height:35px;
    background-color:darkgray;
    color:white;
    font-family:'Arial Black';
    font-size: 17pt;
    font-style:italic;
    font-weight: bold;
    padding-bottom:0px;
    margin-bottom:0px;
    vertical-align: bottom;
  }
  .dialog-question-space
  {
    width:15px;
    background-color:#343F68;
    color:white;
  }
  .dialog-question-space-alt
  {
    width:15px;
    background-color:#19274D;//#666E9B;
    color:white;
  }
  .dialog-question
  {
    height:25px;
    vertical-align: middle;
    background-color:#343F68;
    color:white;
    word-wrap:break-word !important;
  }
  .dialog-input-field-right
  {
    width:15%; //width="10%"
    height:25px;
    vertical-align: top;
    background-color:#343F68;
    color:white;
    text-align: right;
    padding-right:25px;
  }
  .dialog-input-field-right-alt
  {
    width:15%; //width="10%"
    height:25px;
    vertical-align: top;
    background-color:#19274D;//#666E9B;
    color:white;
    text-align: right;
    padding-right:25px;
  }
  .dialog-sub-question
  {
    background-color:#343F68;
    color:white;
    vertical-align:top;
  }
  .dialog-sub-question-alt
  {
    background-color:#19274D;//#666E9B;
    color:white;
    vertical-align:top;
  }
  .dialog-sub-question-div
  {
    width:25px;
  }

  .dialog-input-field-explain
  {
    height:100px;
    vertical-align: middle;
    background-color:#343F68;
    color:white;
    padding-right:25px;
    padding-top:5px;
    width:25%;
    resize:vertical;
    text-align: right;
  }
  .dialog-input-field-explain-alt
  {
    height:100px;
    vertical-align: middle;
    background-color:#19274D;
    color:white;
    padding-right:25px;
    padding-top:5px;
    width:25%;
    resize:vertical;
    text-align: right;
  }
  .dialog-input-submit
  {
    height:50px;
    vertical-align: middle;
    background-color:darkgray;//#343F68;
    color:white;
  }
  .mood
  {
    //padding-right:25px;
    color:white;
    text-align: center;
    background-color:#343F68;
  }
  #mood-1
  {
    width:33%;
    color:white;
    background-color:#343F68;
  }
  #mood-2
  {
    width:66%;
    color:white;
    background-color:#343F68;
  }
  // END TABLE STYLES

  // BEGIN DOT STYLES
  .border-dots
  {
      border-bottom-style:dashed;
      border-bottom-width:1px !important;
      border-bottom-color:#4682B4 !important;
  }
 
  .border-dots-inner
  {
      border-bottom-style:dashed;
      border-bottom-width:1px !important;
      border-bottom-color:#4682B4 !important;
  }

  // END DOT STYLES
  
  // BEGIN CORNER STYLES
 .radius-single-left-field-left-top
  {
    border-top-left-radius:15px;
    overflow:hidden;
  }
  .radius-single-left-field-left-bottom
  {
    border-bottom-left-radius:15px;
    overflow:hidden;
  } 
 .radius-single-left-field-right-top
  {
    //border-top-right-radius:15px;
    overflow:hidden;
  }
  .radius-single-left-field-right-bottom
  {
    //border-bottom-right-radius:15px;
    overflow:hidden;
  }

  .radius-single-right-field-left-top
  {
    //border-top-left-radius:15px;
    overflow:hidden;
  }
  .radius-single-right-field-left-bottom
  {
    //border-bottom-left-radius:15px;
    overflow:hidden;
  }
  .radius-single-right-field-right-top
  {
    border-top-right-radius:15px;
    overflow:hidden;
  }
  .radius-single-right-field-right-bottom
  {
    border-bottom-right-radius:15px;
    overflow:hidden;
  }

  // TOP ROW
  .radius-top-left-field-top
  {
    border-top-left-radius:15px;
    overflow:hidden;
  }
  .radius-top-left-field-bottom
  {
    //border-bottom-left-radius:15px;
    overflow:hidden;
  } 
  .radius-top-right-field-top
  {
    border-top-right-radius:15px;
    overflow:hidden;
  }
  .radius-top-right-field-bottom
  {
    //border-bottom-right-radius:15px;
    overflow:hidden;
  } 


  // BOTTOM ROW
  .radius-bottom-left-field-top
  {
    //border-top-left-radius:15px;
    overflow:hidden;
  }
  .radius-bottom-left-field-bottom
  {
    border-bottom-left-radius:15px;
    overflow:hidden;
  } 
  .radius-bottom-right-field-top
  {
    //border-top-right-radius:15px;
    overflow:hidden;
  }
  .radius-bottom-right-field-bottom
  {
    border-bottom-right-radius:15px;
    overflow:hidden;
  } 

  // END CORNER STYLES
  
  // BEGIN OTHER STYLES  
  .wrap
  {
    word-wrap:break-word !important;
  }
  .col4-width
  {
    width:75% !important;
  }
  #main-table-row3
  {
    height:30px;
  }
  #country select
  {
    width:100px
  }
  #country select:focus
  {
    width:auto;
  }
  // END OTHER STYLES
  
  // BEGIN FOOTER STYLES
  .section-footer
  {
    height:20px;
    background-color:#343F68;
    color:white;
    vertical-align:top;
    width:50%;
  }
  // END FOOTER STYLES
}
</style>